function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function e(t) {
  return e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, e(t);
}
function t(e, t) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, n(i.key), i);
  }
}
function r(e, r, n) {
  return r && t(e.prototype, r), n && t(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function n(t) {
  var r = function (t, r) {
    if ("object" != e(t) || !t) return t;
    var n = t[Symbol.toPrimitive];
    if (void 0 !== n) {
      var i = n.call(t, r || "default");
      if ("object" != e(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }(t, "string");
  return "symbol" == e(r) ? r : String(r);
}
function i(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function o(t, r, n) {
  return r = d(r), function (t, r) {
    if (r && ("object" === e(r) || "function" == typeof r)) return r;
    if (void 0 !== r) throw new TypeError("Derived constructors may only return object or undefined");
    return s(t);
  }(t, u() ? Reflect.construct(r, n || [], d(t).constructor) : r.apply(t, n));
}
function s(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function a(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && l(e, t);
}
function c(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return c = function c(e) {
    if (null === e || !function (e) {
      try {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
      } catch (t) {
        return "function" == typeof e;
      }
    }(e)) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }
    function r() {
      return function (e, t, r) {
        if (u()) return Reflect.construct.apply(null, arguments);
        var n = [null];
        n.push.apply(n, t);
        var i = new (e.bind.apply(e, n))();
        return r && l(i, r.prototype), i;
      }(e, arguments, d(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), l(r, e);
  }, c(e);
}
function u() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (u = function u() {
    return !!e;
  })();
}
function l(e, t) {
  return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, l(e, t);
}
function d(e) {
  return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, d(e);
}
var h, p, _, f, m, v, g;
!function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(h || (h = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(p || (p = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(_ || (_ = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating", e.embeddedOnly = "embeddedOnly", e.floatingOrEmbedded = "floatingOrEmbedded", e.forceLegacyEmbedded = "forceLegacyEmbedded";
}(f || (f = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(m || (m = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_OAUTH_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION", e.B2BSMSOTPSend = "B2B_SMS_OTP_SEND", e.B2BSMSOTPAuthenticate = "B2B_SMS_OTP_AUTHENTICATE", e.B2BTOTPCreate = "B2B_TOTP_CREATE", e.B2BTOTPAuthenticate = "B2B_TOTP_AUTHENTICATE", e.B2BRecoveryCodesRecover = "B2B_RECOVERY_CODES_RECOVER";
}(v || (v = {})), function (e) {
  e[e.emailMagicLinks = 0] = "emailMagicLinks", e[e.oauth = 1] = "oauth", e[e.otp = 2] = "otp", e[e.passwords = 3] = "passwords";
}(g || (g = {}));
var b,
  y,
  k,
  w,
  S = function (e) {
    function t(e, r) {
      var n;
      return i(this, t), (n = o(this, t, [e + "\n" + r])).message = e + "\n" + r, n.name = "SDKAPIUnreachableError", n.details = r, Object.setPrototypeOf(s(n), t.prototype), n;
    }
    return a(t, c(Error)), r(t);
  }(),
  T = function (e) {
    function t(e, r) {
      var n;
      return i(this, t), (n = o(this, t)).name = "StytchSDKUsageError", n.message = "Invalid call to ".concat(e, "\n") + r, n;
    }
    return a(t, c(Error)), r(t);
  }(),
  C = function (e) {
    function t(e) {
      var r, n;
      i(this, t), (r = o(this, t)).name = "StytchSDKSchemaError";
      var s = null === (n = e.body) || void 0 === n ? void 0 : n.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return r.message = "[400] Request does not match expected schema\n".concat(s), r;
    }
    return a(t, c(Error)), r(t);
  }(),
  P = function (e) {
    function t(e) {
      var r;
      i(this, t), (r = o(this, t)).name = "StytchSDKAPIError";
      var n = e.status_code,
        s = e.error_type,
        a = e.error_message,
        c = e.error_url,
        u = e.request_id;
      return r.error_type = s, r.error_message = a, r.error_url = c, r.request_id = u, r.status_code = n, r.message = "[".concat(n, "] ").concat(s, "\n") + "".concat(a, "\n") + "See ".concat(c, " for more information.\n") + (u ? "request_id: ".concat(u, "\n") : ""), r;
    }
    return a(t, c(Error)), r(t);
  }(),
  O = ["unauthorized_credentials", "user_unauthenticated", "invalid_secret_authentication", "session_not_found"],
  E = function (e) {
    function t(e, r) {
      var n;
      return i(this, t), (n = o(this, t, [r])).name = e, n;
    }
    return a(t, c(Error)), r(t);
  }(),
  A = function (e) {
    function t(e) {
      var r;
      return i(this, t), r = o(this, t, ["StytchAPIUnreachableError", e]), Object.setPrototypeOf(s(r), t.prototype), r;
    }
    return a(t, E), r(t);
  }(),
  x = function (e) {
    function t(e) {
      var r;
      i(this, t);
      var n = null === (r = e.body) || void 0 === r ? void 0 : r.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return o(this, t, ["StytchAPISchemaError", "Request does not match expected schema\n".concat(n)]);
    }
    return a(t, E), r(t);
  }(),
  D = function (e) {
    function t(e) {
      var r;
      i(this, t);
      var n = e.status_code,
        s = e.error_type,
        a = e.error_message,
        c = e.error_url,
        u = e.request_id;
      return (r = o(this, t, ["StytchAPIError", "[".concat(n, "] ").concat(s, "\n") + "".concat(a, "\n") + "See ".concat(c, " for more information.\n") + (u ? "request_id: ".concat(u, "\n") : "")])).error_type = s, r.error_message = a, r.error_url = c, r.request_id = u, r.status_code = n, r;
    }
    return a(t, E), r(t);
  }(),
  R = function (e) {
    function t(e, r, n) {
      var s;
      return i(this, t), (s = o(this, t, [e, r])).options = n, s;
    }
    return a(t, E), r(t);
  }(),
  I = function (e) {
    function t() {
      return i(this, t), o(this, t, ["NoCurrentSessionError", "There is no session currently available. Make sure the user is authenticated with a valid session."]);
    }
    return a(t, R), r(t);
  }(),
  B = function (e) {
    function t(e) {
      return i(this, t), o(this, t, ["InternalError", e || "An internal error has occurred. Please contact Stytch if this occurs."]);
    }
    return a(t, R), r(t);
  }(),
  L = function (e) {
    function t() {
      return i(this, t), o(this, t, ["NoBiometricsRegistrationError", "There is no biometric registration available. Authenticate with another method and add a new biometric registration first."]);
    }
    return a(t, R), r(t);
  }(),
  M = function (e) {
    function t() {
      return i(this, t), o(this, t, ["BiometricsUnavailableError", "Biometrics is not available on the device."]);
    }
    return a(t, R), r(t);
  }(),
  F = function (e) {
    function t() {
      return i(this, t), o(this, t, ["KeyInvalidatedError", "The biometrics enrollment on the device has changed."]);
    }
    return a(t, R), r(t);
  }(),
  j = function (e) {
    function t() {
      return i(this, t), o(this, t, ["KeystoreUnavailableError", "The Android keystore is unavailable on the device. Consider setting allowFallbackToCleartext to true."]);
    }
    return a(t, R), r(t);
  }(),
  N = function (e) {
    function t() {
      return i(this, t), o(this, t, ["NoBiometricsEnrolledError", "There is no biometric factor enrolled on the device. Add a biometric factor in the device settings."]);
    }
    return a(t, R), r(t);
  }(),
  K = function (e) {
    function t() {
      return i(this, t), o(this, t, ["UserCancellationError", "The user canceled the prompt. Ask the user to try again."]);
    }
    return a(t, R), r(t);
  }(),
  U = function (e) {
    function t() {
      return i(this, t), o(this, t, ["UserLockedOutError", "The user has been locked out due to too many failed attempts. Ask the user to try again later."]);
    }
    return a(t, R), r(t);
  }(),
  z = function (e) {
    function t() {
      return i(this, t), o(this, t, ["DeviceCredentialsNotAllowedError", "The device credentials allowment is mismatched. Change the allowDeviceCredentials parameter to be the same in both the register and authenticate methods."]);
    }
    return a(t, R), r(t);
  }(),
  q = function (e) {
    function t() {
      return i(this, t), o(this, t, ["MissingGoogleClientIDError", "No Google client ID was found in the project."]);
    }
    return a(t, R), r(t);
  }(),
  G = function (e) {
    function t() {
      return i(this, t), o(this, t, ["MissingPKCEError", "Make sure this flow is completed on the same device on which it was started."]);
    }
    return a(t, R), r(t);
  }(),
  W = function (e) {
    function t() {
      return i(this, t), o(this, t, ["MissingAuthorizationCredentialIDTokenError", "The authorization credential is missing an ID token."]);
    }
    return a(t, R), r(t);
  }(),
  H = function (e) {
    function t() {
      return i(this, t), o(this, t, ["InvalidAuthorizationCredentialError", "The authorization credential is invalid. Verify that OAuth is set up correctly in the developer console, and call the start flow method."]);
    }
    return a(t, R), r(t);
  }(),
  Y = function (e) {
    function t() {
      return i(this, t), o(this, t, ["NoCredentialsPresentError", "The user did not provide credentials for a Google OneTap attempt"]);
    }
    return a(t, R), r(t);
  }(),
  V = function (e) {
    function t() {
      return i(this, t), o(this, t, ["MissingPublicKeyError", "Failed to retrieve the public key. Add a new biometric registration."]);
    }
    return a(t, R), r(t);
  }(),
  J = function (e) {
    function t() {
      return i(this, t), o(this, t, ["ChallengeSigningFailedError", "Failed to sign the challenge with the key."]);
    }
    return a(t, R), r(t);
  }(),
  $ = function (e) {
    function t() {
      return i(this, t), o(this, t, ["SDKNotConfiguredError", "Stytch client is not confiured. You must call the configure method before using the SDK"]);
    }
    return a(t, R), r(t);
  }(),
  X = function (e) {
    function t() {
      return i(this, t), o(this, t, ["FailedCodeChallengeError", "Failed to create a code challenge"]);
    }
    return a(t, R), r(t);
  }(),
  Z = function (e) {
    function t() {
      return i(this, t), o(this, t, ["PasskeysUnsupportedError", "Passkeys are not supported on this device"]);
    }
    return a(t, R), r(t);
  }(),
  Q = function (e) {
    function t() {
      return i(this, t), o(this, t, ["FailedToDecryptDataError", "Failed to decrypt user data"]);
    }
    return a(t, R), r(t);
  }(),
  ee = function (e) {
    function t() {
      return i(this, t), o(this, t, ["BiometricsFailedError", "Biometric authentication failed"]);
    }
    return a(t, R), r(t);
  }(),
  te = function (e) {
    function t() {
      return i(this, t), o(this, t, ["InvalidStartUrlError", "The start URL was invalid or improperly formatted."]);
    }
    return a(t, R), r(t);
  }(),
  re = function (e) {
    function t() {
      return i(this, t), o(this, t, ["InvalidRedirectSchemeError", "The scheme from the given redirect urls was invalid. Possible reasons include: nil scheme, non-custom scheme (using http or https), or differing schemes for login/signup urls."]);
    }
    return a(t, R), r(t);
  }(),
  ne = function (e) {
    function t() {
      return i(this, t), o(this, t, ["MissingUrlError", "The underlying web authentication service failed to return a URL."]);
    }
    return a(t, R), r(t);
  }(),
  ie = function (e) {
    function t() {
      return i(this, t), o(this, t, ["InvalidCredentialTypeError", "The public key credential type was not of the expected type."]);
    }
    return a(t, R), r(t);
  }(),
  oe = function (e) {
    function t() {
      return i(this, t), o(this, t, ["MissingAttestationObjectError", "The public key credential is missing the attestation object."]);
    }
    return a(t, R), r(t);
  }(),
  se = function (e) {
    function t() {
      return i(this, t), o(this, t, ["JSONDataNotConvertibleToStringError", "JSON data unable to be converted to String type."]);
    }
    return a(t, R), r(t);
  }(),
  ae = function (e) {
    function t() {
      return i(this, t), o(this, t, ["RandomNumberGenerationFailed", "Random number generation failed"]);
    }
    return a(t, R), r(t);
  }(),
  ce = function (e) {
    function t() {
      return i(this, t), o(this, t, ["PasskeysInvalidEncoding", "Invalid passkey encoding"]);
    }
    return a(t, R), r(t);
  }(),
  ue = function (e) {
    function t() {
      return i(this, t), o(this, t, ["PasskeysMisconfigured", "Passkeys are misconfigured. Verify that you have added the correct associated domain for your application, and that the signing information is correct."]);
    }
    return a(t, R), r(t);
  }(),
  le = function (e) {
    function t() {
      return i(this, t), o(this, t, ["SignInWithAppleMisconfigured", "Sign In With Apple is misconfigured. Verify that you have correctly configured Apple OAuth in the Stytch Dashboard and added the Sign In With Apple capability to your project."]);
    }
    return a(t, R), r(t);
  }();
function de(e) {
  switch (e.message) {
    case "internal_error":
      return new B(e.message);
    case "no_current_session":
      return new I();
    case "no_biometrics_registration":
      return new L();
    case "biometrics_unavailable":
    case "device_hardware_error":
    case "biometrics_not_available":
      return new M();
    case "key_invalidated":
    case "no_biometric_key":
      return new F();
    case "no_biometrics_enrolled":
      return new N();
    case "keystore_unavailable":
      return new j();
    case "device_credentials_not_allowed":
      return new z();
    case "user_cancellation":
      return new K();
    case "user_locked_out":
      return new U();
    case "google_onetap_missing_id_token":
    case "oauth_apple_missing_id_token":
    case "missing_authorization_credential_id_token":
      return new W();
    case "google_onetap_missing_member":
    case "oauth_apple_credential_invalid":
    case "invalid_authorization_credential":
      return new H();
    case "missing_public_key":
      return new V();
    case "challenge_signing_failed":
      return new J();
    case "no_credentials_present":
      return new Y();
    case "sdk_not_configured":
      return new $();
    case "failed_code_challenge":
      return new X();
    case "passkeys_unsupported":
      return new Z();
    case "failed_to_decrypt_data":
      return new Q();
    case "biometrics_failed":
      return new ee();
    case "invalid_start_url":
      return new te();
    case "invalid_redirect_scheme":
      return new re();
    case "missing_url":
      return new ne();
    case "invalid_credential_type":
      return new ie();
    case "missing_attestation_object":
      return new oe();
    case "json_data_not_convertible_to_string":
      return new se();
    case "random_number_generation_failed":
      return new ae();
    case "passkeys_invalid_encoding":
      return new ce();
    case "passkeys_misconfigured":
      return new ue();
    case "signinwithapple_misconfigured":
      return new le();
    default:
      return new R(e.name, e.message);
  }
}
function he(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return pe(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return pe(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var _n = 0,
        i = function i() {};
      return {
        s: i,
        n: function n() {
          return _n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[_n++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: i
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    s = !0,
    a = !1;
  return {
    s: function s() {
      r = r.call(e);
    },
    n: function n() {
      var e = r.next();
      return s = e.done, e;
    },
    e: function e(_e3) {
      a = !0, o = _e3;
    },
    f: function f() {
      try {
        s || null == r["return"] || r["return"]();
      } finally {
        if (a) throw o;
      }
    }
  };
}
function pe(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function _e(e) {
  return _e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, _e(e);
}
function fe() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  fe = function fe() {
    return t;
  };
  var e,
    t = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    i = Object.defineProperty || function (e, t, r) {
      e[t] = r.value;
    },
    o = "function" == typeof Symbol ? Symbol : {},
    s = o.iterator || "@@iterator",
    a = o.asyncIterator || "@@asyncIterator",
    c = o.toStringTag || "@@toStringTag";
  function u(e, t, r) {
    return Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    u({}, "");
  } catch (e) {
    u = function u(e, t, r) {
      return e[t] = r;
    };
  }
  function l(e, t, r, n) {
    var o = t && t.prototype instanceof v ? t : v,
      s = Object.create(o.prototype),
      a = new x(n || []);
    return i(s, "_invoke", {
      value: P(e, r, a)
    }), s;
  }
  function d(e, t, r) {
    try {
      return {
        type: "normal",
        arg: e.call(t, r)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = l;
  var h = "suspendedStart",
    p = "suspendedYield",
    _ = "executing",
    f = "completed",
    m = {};
  function v() {}
  function g() {}
  function b() {}
  var y = {};
  u(y, s, function () {
    return this;
  });
  var k = Object.getPrototypeOf,
    w = k && k(k(D([])));
  w && w !== r && n.call(w, s) && (y = w);
  var S = b.prototype = v.prototype = Object.create(y);
  function T(e) {
    ["next", "throw", "return"].forEach(function (t) {
      u(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function C(e, t) {
    function r(i, o, s, a) {
      var c = d(e[i], e, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          l = u.value;
        return l && "object" == _e(l) && n.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
          r("next", e, s, a);
        }, function (e) {
          r("throw", e, s, a);
        }) : t.resolve(l).then(function (e) {
          u.value = e, s(u);
        }, function (e) {
          return r("throw", e, s, a);
        });
      }
      a(c.arg);
    }
    var o;
    i(this, "_invoke", {
      value: function value(e, n) {
        function i() {
          return new t(function (t, i) {
            r(e, n, t, i);
          });
        }
        return o = o ? o.then(i, i) : i();
      }
    });
  }
  function P(t, r, n) {
    var i = h;
    return function (o, s) {
      if (i === _) throw new Error("Generator is already running");
      if (i === f) {
        if ("throw" === o) throw s;
        return {
          value: e,
          done: !0
        };
      }
      for (n.method = o, n.arg = s;;) {
        var a = n.delegate;
        if (a) {
          var c = O(a, n);
          if (c) {
            if (c === m) continue;
            return c;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (i === h) throw i = f, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        i = _;
        var u = d(t, r, n);
        if ("normal" === u.type) {
          if (i = n.done ? f : p, u.arg === m) continue;
          return {
            value: u.arg,
            done: n.done
          };
        }
        "throw" === u.type && (i = f, n.method = "throw", n.arg = u.arg);
      }
    };
  }
  function O(t, r) {
    var n = r.method,
      i = t.iterator[n];
    if (i === e) return r.delegate = null, "throw" === n && t.iterator["return"] && (r.method = "return", r.arg = e, O(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
    var o = d(i, t.iterator, r.arg);
    if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, m;
    var s = o.arg;
    return s ? s.done ? (r[t.resultName] = s.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : s : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
  }
  function E(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function A(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function x(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(E, this), this.reset(!0);
  }
  function D(t) {
    if (t || "" === t) {
      var r = t[s];
      if (r) return r.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var i = -1,
          o = function r() {
            for (; ++i < t.length;) if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
            return r.value = e, r.done = !0, r;
          };
        return o.next = o;
      }
    }
    throw new TypeError(_e(t) + " is not iterable");
  }
  return g.prototype = b, i(S, "constructor", {
    value: b,
    configurable: !0
  }), i(b, "constructor", {
    value: g,
    configurable: !0
  }), g.displayName = u(b, c, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, b) : (e.__proto__ = b, u(e, c, "GeneratorFunction")), e.prototype = Object.create(S), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, T(C.prototype), u(C.prototype, a, function () {
    return this;
  }), t.AsyncIterator = C, t.async = function (e, r, n, i, o) {
    void 0 === o && (o = Promise);
    var s = new C(l(e, r, n, i), o);
    return t.isGeneratorFunction(r) ? s : s.next().then(function (e) {
      return e.done ? e.value : s.next();
    });
  }, T(S), u(S, c, "Generator"), u(S, s, function () {
    return this;
  }), u(S, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      r = [];
    for (var n in t) r.push(n);
    return r.reverse(), function e() {
      for (; r.length;) {
        var n = r.pop();
        if (n in t) return e.value = n, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = D, x.prototype = {
    constructor: x,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(A), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var r = this;
      function i(n, i) {
        return a.type = "throw", a.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var s = this.tryEntries[o],
          a = s.completion;
        if ("root" === s.tryLoc) return i("end");
        if (s.tryLoc <= this.prev) {
          var c = n.call(s, "catchLoc"),
            u = n.call(s, "finallyLoc");
          if (c && u) {
            if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
            if (this.prev < s.finallyLoc) return i(s.finallyLoc);
          } else if (c) {
            if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < s.finallyLoc) return i(s.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var i = this.tryEntries[r];
        if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
          var o = i;
          break;
        }
      }
      o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
      var s = o ? o.completion : {};
      return s.type = e, s.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, m) : this.complete(s);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), A(r), m;
      }
    },
    "catch": function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc === e) {
          var n = r.completion;
          if ("throw" === n.type) {
            var i = n.arg;
            A(r);
          }
          return i;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, r, n) {
      return this.delegate = {
        iterator: D(t),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = e), m;
    }
  }, t;
}
function me(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ge(n.key), n);
  }
}
function ve(e, t, r) {
  return t && me(e.prototype, t), r && me(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ge(e) {
  var t = function (e, t) {
    if ("object" != _e(e) || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" != _e(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" == _e(t) ? t : String(t);
}
function be(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ye(e, t, r) {
  return t = Te(t), function (e, t) {
    if (t && ("object" === _e(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e);
  }(e, we() ? Reflect.construct(t, r || [], Te(e).constructor) : t.apply(e, r));
}
function ke(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return ke = function ke(e) {
    if (null === e || !function (e) {
      try {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
      } catch (t) {
        return "function" == typeof e;
      }
    }(e)) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }
    function r() {
      return function (e, t, r) {
        if (we()) return Reflect.construct.apply(null, arguments);
        var n = [null];
        n.push.apply(n, t);
        var i = new (e.bind.apply(e, n))();
        return r && Se(i, r.prototype), i;
      }(e, arguments, Te(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Se(r, e);
  }, ke(e);
}
function we() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (we = function we() {
    return !!e;
  })();
}
function Se(e, t) {
  return Se = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, Se(e, t);
}
function Te(e) {
  return Te = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Te(e);
}
!function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(b || (b = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(y || (y = {})), function (e) {
  e.smsOtp = "smsOtp", e.totp = "totp";
}(k || (k = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(w || (w = {}));
var Ce,
  Pe = "https://accounts.google.com/gsi",
  Oe = "".concat(Pe, "/client");
function Ee(e, t, r, n) {
  return new (r || (r = Promise))(function (i, o) {
    function s(e) {
      try {
        c(n.next(e));
      } catch (e) {
        o(e);
      }
    }
    function a(e) {
      try {
        c(n["throw"](e));
      } catch (e) {
        o(e);
      }
    }
    function c(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(s, a);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError, (Ce || (Ce = {})).RequiredCatcha = "Catcha Required";
var Ae,
  xe = function (e) {
    function t(e) {
      var r;
      return be(this, t), (r = ye(this, t, [e])).type = e, r;
    }
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Se(e, t);
    }(t, ke(Error)), ve(t);
  }();
function De(e) {
  var t,
    r = e.method,
    n = e.finalURL,
    i = e.basicAuthHeader,
    o = e.xSDKClientHeader,
    s = e.xSDKParentHostHeader,
    a = e.body;
  return Ee(this, void 0, void 0, fe().mark(function e() {
    var c, u, l, d, h, p;
    return fe().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return c = {
            Authorization: i,
            "Content-Type": "application/json",
            "X-SDK-Client": o
          }, s && (c["X-SDK-Parent-Host"] = s), u = {
            method: r,
            headers: c,
            body: a && JSON.stringify(a)
          }, e.prev = 3, e.next = 6, fetch(n, u);
        case 6:
          l = e.sent, e.next = 14;
          break;
        case 9:
          if (e.prev = 9, e.t0 = e["catch"](3), "Failed to fetch" !== e.t0.message) {
            e.next = 13;
            break;
          }
          throw new A("Unable to contact the Stytch servers. Are you online?");
        case 13:
          throw e.t0;
        case 14:
          if (!(l.status <= 299)) {
            e.next = 25;
            break;
          }
          return e.prev = 15, e.next = 18, l.json();
        case 18:
          return d = e.sent, e.abrupt("return", d.data);
        case 22:
          throw e.prev = 22, e.t1 = e["catch"](15), new A("Invalid JSON response from the Stytch servers.");
        case 25:
          if (200 === l.status || !(null === (t = l.headers.get("content-type")) || void 0 === t ? void 0 : t.includes("application/json"))) {
            e.next = 38;
            break;
          }
          return e.prev = 26, e.next = 29, l.json();
        case 29:
          h = e.sent, e.next = 35;
          break;
        case 32:
          throw e.prev = 32, e.t2 = e["catch"](26), new A("Invalid or no response from server");
        case 35:
          if (!("body" in h || "params" in h || "query" in h)) {
            e.next = 37;
            break;
          }
          throw new x(h);
        case 37:
          throw new D(h);
        case 38:
          return e.prev = 38, e.next = 41, l.text();
        case 41:
          p = e.sent, e.next = 47;
          break;
        case 44:
          throw e.prev = 44, e.t3 = e["catch"](38), new A("Invalid response from the Stytch servers.");
        case 47:
          if (!p.includes("Captcha required")) {
            e.next = 49;
            break;
          }
          throw new xe(Ce.RequiredCatcha);
        case 49:
          throw new A("Invalid response from the Stytch servers.");
        case 50:
        case "end":
          return e.stop();
      }
    }, e, null, [[3, 9], [15, 22], [26, 32], [38, 44]]);
  }));
}
var Re = new Uint8Array(16);
function Ie() {
  if (!Ae && !(Ae = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ae(Re);
}
var Be = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
for (var Le = [], Me = 0; Me < 256; ++Me) Le.push((Me + 256).toString(16).substr(1));
function Fe(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    r = (Le[e[t + 0]] + Le[e[t + 1]] + Le[e[t + 2]] + Le[e[t + 3]] + "-" + Le[e[t + 4]] + Le[e[t + 5]] + "-" + Le[e[t + 6]] + Le[e[t + 7]] + "-" + Le[e[t + 8]] + Le[e[t + 9]] + "-" + Le[e[t + 10]] + Le[e[t + 11]] + Le[e[t + 12]] + Le[e[t + 13]] + Le[e[t + 14]] + Le[e[t + 15]]).toLowerCase();
  if (!function (e) {
    return "string" == typeof e && Be.test(e);
  }(r)) throw TypeError("Stringified UUID is invalid");
  return r;
}
function je(e, t, r) {
  var n = (e = e || {}).random || (e.rng || Ie)();
  if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, t) {
    r = r || 0;
    for (var i = 0; i < 16; ++i) t[r + i] = n[i];
    return t;
  }
  return Fe(n);
}
var Ne = {};
function Ke(e, t) {
  return Ee(this, void 0, void 0, fe().mark(function r() {
    return fe().wrap(function (r) {
      for (;;) switch (r.prev = r.next) {
        case 0:
          if (void 0 === Ne[e]) {
            r.next = 2;
            break;
          }
          return r.abrupt("return", Ne[e]);
        case 2:
          return Ne[e] = Ue(e, t), r.abrupt("return", Ne[e]);
        case 4:
        case "end":
          return r.stop();
      }
    }, r);
  }));
}
function Ue(e, t) {
  return new Promise(function (r, n) {
    var i = function (e) {
      var t = ze(e);
      if (t[0]) return t[0];
    }(e);
    if (i && "true" === i.dataset.loaded) try {
      r(t());
    } catch (t) {
      return n(new Error("".concat(e, " already loaded, but module was not found in global scope: ").concat(t)));
    }
    var o = function (e) {
      var t = document.createElement("script");
      return t.setAttribute("src", e), t.setAttribute("async", "true"), t.setAttribute("defer", "true"), document.head.appendChild(t), t;
    }(e);
    o.addEventListener("load", function () {
      o.dataset.loaded = "true";
      try {
        r(t());
      } catch (t) {
        n(new Error("".concat(e, " was loaded, but module was not found in global scope: ").concat(t)));
      }
    }), o.addEventListener("error", function (t) {
      n(new Error("".concat(e, " could not be loaded: ").concat(t)));
    });
  });
}
var ze = function ze(e) {
  return document.querySelectorAll('script[src="'.concat(e, '"]'));
};
var qe,
  Ge = ["[Stytch]"],
  We = function We() {
    for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
    return (e = console).warn.apply(e, Ge.concat(r));
  },
  He = function He() {
    for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
    return (e = console).error.apply(e, Ge.concat(r));
  },
  Ye = "\nYou can find your public token at https://stytch.com/dashboard/api-keys.",
  Ve = function Ve(e) {
    return e.includes("public-token-test");
  },
  Je = function Je(e) {
    var t = {
      isObject: function isObject(r, n) {
        var i = "object" === _e(n) && !Array.isArray(n) && null !== n;
        if (!i) throw new T(e, r + " must be an object.");
        return t;
      },
      isOptionalObject: function isOptionalObject(e, r) {
        return void 0 === r ? t : t.isObject(e, r);
      },
      isString: function isString(r, n) {
        if ("string" != typeof n) throw new T(e, r + " must be a string.");
        return t;
      },
      isOptionalString: function isOptionalString(e, r) {
        return void 0 === r ? t : t.isString(e, r);
      },
      isStringArray: function isStringArray(r, n) {
        if (!Array.isArray(n)) throw new T(e, r + " must be an array of strings.");
        var i,
          o = he(n);
        try {
          for (o.s(); !(i = o.n()).done;) {
            if ("string" != typeof i.value) throw new T(e, r + " must be an array of strings.");
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return t;
      },
      isOptionalStringArray: function isOptionalStringArray(e, r) {
        return void 0 === r ? t : t.isStringArray(e, r);
      },
      isNumber: function isNumber(r, n) {
        if ("number" != typeof n) throw new T(e, r + " must be a number.");
        return t;
      },
      isOptionalNumber: function isOptionalNumber(e, r) {
        return void 0 === r ? t : t.isNumber(e, r);
      },
      isBoolean: function isBoolean(r, n) {
        if ("boolean" != typeof n) throw new T(e, r + " must be a boolean.");
        return t;
      },
      isOptionalBoolean: function isOptionalBoolean(e, r) {
        return void 0 === r ? t : t.isBoolean(e, r);
      }
    };
    return t;
  },
  $e = ve(function e(t, r, n) {
    var i = this,
      o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {
        return Promise.resolve(void 0);
      };
    be(this, e), this.bootstrapPromise = n, this.isEnabled = function () {
      return Ee(i, void 0, void 0, fe().mark(function e() {
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.state.then(function (e) {
                return e.enabled;
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getTelemetryID = function () {
      return Ee(i, void 0, void 0, fe().mark(function e() {
        var t, r, n, i;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, r = t.publicToken, n = t.enabled, i = t.dfpBackendURL, n) {
                e.next = 8;
                break;
              }
              return e.abrupt("return", void 0);
            case 8:
              return e.next = 10, window.GetTelemetryID(r, "".concat(i, "/submit"));
            case 10:
              return e.abrupt("return", e.sent);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getDFPTelemetryIDAndCaptcha = function () {
      return Ee(i, void 0, void 0, fe().mark(function e() {
        var t, r, n, i, o, s;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, r = t.enabled, n = t.executeRecaptcha, i = t.mode, o = void 0, s = void 0, r) {
                e.next = 12;
                break;
              }
              return e.next = 11, n();
            case 11:
              s = e.sent;
            case 12:
              if ("DECISIONING" !== i) {
                e.next = 18;
                break;
              }
              return e.next = 15, this.getTelemetryID();
            case 15:
              o = e.sent, e.next = 25;
              break;
            case 18:
              if ("OBSERVATION" !== i) {
                e.next = 25;
                break;
              }
              return e.next = 21, this.getTelemetryID();
            case 21:
              return o = e.sent, e.next = 24, n();
            case 24:
              s = e.sent;
            case 25:
              return e.abrupt("return", {
                dfp_telemetry_id: o,
                captcha_token: s
              });
            case 26:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.retryWithCaptchaAndDFP = function (e, t) {
      return Ee(i, void 0, void 0, fe().mark(function r() {
        var n, i, o;
        return fe().wrap(function (r) {
          for (;;) switch (r.prev = r.next) {
            case 0:
              return r.next = 2, this.state;
            case 2:
              if (n = r.sent, i = n.enabled, o = n.executeRecaptcha, e.type !== Ce.RequiredCatcha || !i) {
                r.next = 14;
                break;
              }
              if (!t.body) {
                r.next = 13;
                break;
              }
              return r.next = 9, this.getTelemetryID();
            case 9:
              return t.body.dfp_telemetry_id = r.sent, r.next = 12, o();
            case 12:
              t.body.captcha_token = r.sent;
            case 13:
              return r.abrupt("return", t);
            case 14:
              throw new Error("Unable to query captcha and/or dfp telemetry ID");
            case 15:
            case "end":
              return r.stop();
          }
        }, r, this);
      }));
    }, this.state = n.then(function (e) {
      return Ee(i, void 0, void 0, fe().mark(function n() {
        return fe().wrap(function (n) {
          for (;;) switch (n.prev = n.next) {
            case 0:
              if (e.runDFPProtectedAuth) {
                n.next = 2;
                break;
              }
              return n.abrupt("return", {
                publicToken: t,
                dfpBackendURL: r,
                enabled: !1,
                loaded: !1,
                executeRecaptcha: o
              });
            case 2:
              return n.next = 4, Ke("".concat("https://elements.stytch.com", "/telemetry.js"), function () {
                return window.GetTelemetryID;
              });
            case 4:
              return n.abrupt("return", {
                publicToken: t,
                dfpBackendURL: r,
                enabled: !0,
                mode: e.dfpProtectedAuthMode || "OBSERVATION",
                loaded: !0,
                executeRecaptcha: o
              });
            case 5:
            case "end":
              return n.stop();
          }
        }, n);
      }));
    });
  }),
  Xe = function Xe() {
    return {
      isEnabled: function isEnabled() {
        return Ee(void 0, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !1);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getTelemetryID: function getTelemetryID() {
        return Ee(void 0, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", void 0);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getDFPTelemetryIDAndCaptcha: function getDFPTelemetryIDAndCaptcha() {
        return Ee(void 0, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", {
                  dfp_telemetry_id: void 0,
                  captcha_token: void 0
                });
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      retryWithCaptchaAndDFP: function retryWithCaptchaAndDFP() {
        return Ee(void 0, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                throw new Error("DFP protected auth is disabled");
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      }
    };
  },
  Ze = function () {
    function e() {
      be(this, e);
    }
    return ve(e, null, [{
      key: "marshall",
      value: function value(e) {
        return Object.assign(Object.assign({}, e), {
          name: e.name,
          message: e.message,
          stack: e.stack
        });
      }
    }, {
      key: "inflate",
      value: function value(e, t) {
        var r = new e(t);
        return Object.assign(r, t), Object.setPrototypeOf(r, e.prototype), r;
      }
    }, {
      key: "unmarshall",
      value: function value(t) {
        if ("name" in t) switch (t.name) {
          case "SDKAPIUnreachableError":
            return e.inflate(S, t);
          case "StytchSDKSchemaError":
            return e.inflate(C, t);
          case "StytchAPIUnreachableError":
            return e.inflate(A, t);
          case "StytchAPISchemaError":
            return e.inflate(x, t);
          case "StytchSDKAPIError":
            return e.inflate(P, t);
          case "StytchAPIError":
            return e.inflate(D, t);
          case "TypeError":
            return e.inflate(TypeError, t);
          case "SyntaxError":
            return e.inflate(SyntaxError, t);
          case "ReferenceError":
            return e.inflate(ReferenceError, t);
          case "RangeError":
            return e.inflate(RangeError, t);
          case "EvalError":
            return e.inflate(EvalError, t);
          case "URIError":
            return e.inflate(URIError, t);
        }
        return e.inflate(Error, t);
      }
    }]), e;
  }(),
  Qe = function () {
    function e(t) {
      be(this, e), this.maxBatchSize = t.maxBatchSize, this.logEventURL = t.logEventURL, setInterval(this.flush.bind(this), t.intervalDurationMs), this.batch = [];
    }
    return ve(e, [{
      key: "logEvent",
      value: function value(e, t) {
        this.batch.push({
          telemetry: e,
          event: t
        }), this.batch.length >= this.maxBatchSize && this.flush();
      }
    }, {
      key: "flush",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          var t;
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (this.batch.length) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return t = this.batch, this.batch = [], e.prev = 4, e.next = 7, fetch(this.logEventURL, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(t)
                });
              case 7:
                e.next = 11;
                break;
              case 9:
                e.prev = 9, e.t0 = e["catch"](4);
              case 11:
              case "end":
                return e.stop();
            }
          }, e, this, [[4, 9]]);
        }));
      }
    }]), e;
  }();
!function (e) {
  e.LoginOrCreateEML = "login_or_create_eml", e.LoginOrCreateOTP = "login_or_create_otp", e.ResetPassword = "reset_password";
}(qe || (qe = {})), Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var et = Promise.resolve({
    pkceRequiredForEmailMagicLinks: !1
  }),
  tt = function () {
    function e(t, r, n, i) {
      var o = this,
        s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : et,
        a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : Xe();
      be(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._passwordResetPKCEManager = i, this._config = s, this.dfpProtectedAuth = a, this.email = {
        invite: function invite(e) {
          return Ee(o, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return Je("stytch.magicLinks.email.loginOrSignup").isString("email_address", e.email_address).isOptionalString("invite_redirect_url", e.invite_redirect_url).isOptionalString("invite_template_id", e.invite_template_id).isOptionalString("name", e.name).isOptionalString("locale", e.locale).isOptionalStringArray("roles", e.roles), t.abrupt("return", this._networkClient.fetchSDK({
                    url: "/b2b/magic_links/email/invite",
                    body: e,
                    errorMessage: "Failed to send invite.",
                    method: "POST"
                  }));
                case 2:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        loginOrSignup: function loginOrSignup(e) {
          return Ee(o, void 0, void 0, fe().mark(function t() {
            var r, n;
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return Je("stytch.magicLinks.email.loginOrSignup").isString("email_address", e.email_address).isString("organization_id", e.organization_id).isOptionalString("login_redirect_url", e.login_redirect_url).isOptionalString("login_template_id", e.login_template_id).isOptionalString("signup_redirect_url", e.signup_redirect_url).isOptionalString("signup_template_id", e.signup_template_id).isOptionalString("locale", e.locale), t.next = 3, this.getCodeChallenge();
                case 3:
                  return r = t.sent, n = Object.assign(Object.assign({}, e), {
                    pkce_code_challenge: r
                  }), t.abrupt("return", this._networkClient.fetchSDK({
                    url: "/b2b/magic_links/email/login_or_signup",
                    body: n,
                    errorMessage: "Failed to send magic link",
                    method: "POST"
                  }));
                case 6:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        discovery: {
          send: function send(e) {
            return Ee(o, void 0, void 0, fe().mark(function t() {
              var r, n;
              return fe().wrap(function (t) {
                for (;;) switch (t.prev = t.next) {
                  case 0:
                    return Je("stytch.magicLinks.email.discovery.send").isString("email_address", e.email_address).isOptionalString("discovery_redirect_url", e.discovery_redirect_url).isOptionalString("login_template_id", e.login_template_id).isOptionalString("locale", e.locale), t.next = 3, this.getCodeChallenge();
                  case 3:
                    return r = t.sent, n = Object.assign(Object.assign({}, e), {
                      pkce_code_challenge: r
                    }), t.abrupt("return", this._networkClient.fetchSDK({
                      url: "/b2b/magic_links/email/discovery/send",
                      body: n,
                      errorMessage: "Failed to send discovery magic link",
                      method: "POST"
                    }));
                  case 6:
                  case "end":
                    return t.stop();
                }
              }, t, this);
            }));
          }
        }
      }, this.authenticate = function (e) {
        return Ee(o, void 0, void 0, fe().mark(function t() {
          var r, n;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.magicLinks.authenticate").isString("magic_links_token", e.magic_links_token).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._passwordResetPKCEManager.getPKPair();
              case 3:
                if (r = t.sent, n = null, !(null == r ? void 0 : r.code_verifier)) {
                  t.next = 19;
                  break;
                }
                return t.prev = 6, t.next = 9, this.handlePKCEForAuthenticate(this._passwordResetPKCEManager, e);
              case 9:
                n = t.sent, t.next = 19;
                break;
              case 12:
                if (t.prev = 12, t.t0 = t["catch"](6), !t.t0.message.includes("pkce")) {
                  t.next = 18;
                  break;
                }
                console.log("Authenticate with passwords pkce namespace failed. Falling back to authenticate with magic_links namespace."), t.next = 19;
                break;
              case 18:
                throw t.t0;
              case 19:
                if (n) {
                  t.next = 23;
                  break;
                }
                return t.next = 22, this.handlePKCEForAuthenticate(this._pkceManager, e);
              case 22:
                n = t.sent;
              case 23:
                return n.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: n.member_session,
                    member: n.member,
                    organization: n.organization
                  },
                  session_token: n.session_token,
                  session_jwt: n.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: n.intermediate_session_token
                }), t.abrupt("return", n);
              case 25:
              case "end":
                return t.stop();
            }
          }, t, this, [[6, 12]]);
        }));
      }, this.discovery = {
        authenticate: function authenticate(e) {
          return Ee(o, void 0, void 0, fe().mark(function t() {
            var r, n, i, o, s, a;
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return Je("stytch.magicLinks.discovery.authenticate").isString("discovery_magic_links_token", e.discovery_magic_links_token), t.next = 3, this._pkceManager.getPKPair();
                case 3:
                  return r = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 6:
                  return n = t.sent, i = n.dfp_telemetry_id, o = n.captcha_token, s = Object.assign({
                    pkce_code_verifier: null == r ? void 0 : r.code_verifier,
                    dfp_telemetry_id: i,
                    captcha_token: o
                  }, e), t.next = 12, this._networkClient.retriableFetchSDK({
                    url: "/b2b/magic_links/discovery/authenticate",
                    body: s,
                    errorMessage: "Failed to authenticate intermediate magic link token",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  });
                case 12:
                  return a = t.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                    state: null,
                    session_token: null,
                    session_jwt: null,
                    intermediate_session_token: a.intermediate_session_token
                  }), t.abrupt("return", a);
                case 16:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        }
      };
    }
    return ve(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          var t, r;
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._config;
              case 2:
                if (t = e.sent, t.pkceRequiredForEmailMagicLinks) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", void 0);
              case 6:
                return e.next = 8, this._pkceManager.getPKPair();
              case 8:
                if (!(r = e.sent)) {
                  e.next = 11;
                  break;
                }
                return e.abrupt("return", r.code_challenge);
              case 11:
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                return r = e.sent, e.abrupt("return", r.code_challenge);
              case 15:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "handlePKCEForAuthenticate",
      value: function value(e, t) {
        return Ee(this, void 0, void 0, fe().mark(function r() {
          var n, i, o, s, a, c;
          return fe().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, e.getPKPair();
              case 2:
                return n = r.sent, r.next = 5, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 5:
                return i = r.sent, o = i.dfp_telemetry_id, s = i.captcha_token, r.t0 = Object, r.t1 = null == n ? void 0 : n.code_verifier, r.t2 = o, r.t3 = s, r.next = 14, this._subscriptionService.getIntermediateSessionToken();
              case 14:
                if (r.t4 = r.sent, r.t4) {
                  r.next = 17;
                  break;
                }
                r.t4 = void 0;
              case 17:
                return r.t5 = r.t4, r.t6 = {
                  pkce_code_verifier: r.t1,
                  dfp_telemetry_id: r.t2,
                  captcha_token: r.t3,
                  intermediate_session_token: r.t5
                }, r.t7 = t, a = r.t0.assign.call(r.t0, r.t6, r.t7), r.next = 23, this._networkClient.retriableFetchSDK({
                  url: "/b2b/magic_links/authenticate",
                  body: a,
                  errorMessage: "Failed to authenticate token",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 23:
                return c = r.sent, e.clearPKPair(), r.abrupt("return", c);
              case 26:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }]), e;
  }(),
  rt = ve(function e(t, r) {
    var n = this;
    be(this, e), this._networkClient = t, this._subscriptionService = r, this.get = function () {
      return Ee(n, void 0, void 0, fe().mark(function e() {
        var t;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/me",
                errorMessage: "Failed to retrieve member info.",
                method: "GET"
              });
            case 2:
              return t = e.sent, this._subscriptionService.updateMember(t.member), e.abrupt("return", t.member);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getSync = function () {
      return n._subscriptionService.getMember();
    }, this.getInfo = function () {
      return {
        member: n.getSync(),
        fromCache: n._subscriptionService.getFromCache()
      };
    }, this.onChange = function (e) {
      return n._subscriptionService.subscribeToState(function (t) {
        var r;
        return e(null !== (r = null == t ? void 0 : t.member) && void 0 !== r ? r : null);
      });
    }, this.update = function (e) {
      return Ee(n, void 0, void 0, fe().mark(function t() {
        var r;
        return fe().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return Je("stytch.self.update").isOptionalString("name", e.name).isOptionalObject("untrusted_metadata", e.untrusted_metadata).isOptionalBoolean("mfa_enrolled", e.mfa_enrolled).isOptionalString("mfa_phone_number", e.mfa_phone_number).isOptionalString("default_mfa_method", e.default_mfa_method), t.next = 3, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/update",
                body: e,
                errorMessage: "Failed to update member.",
                method: "PUT"
              });
            case 3:
              return r = t.sent, this._subscriptionService.updateMember(r.member), t.abrupt("return", r);
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteMFAPhoneNumber = function () {
      return Ee(n, void 0, void 0, fe().mark(function e() {
        var t;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/deletePhoneNumber",
                errorMessage: "Failed to delete member phone number.",
                method: "DELETE"
              });
            case 2:
              return t = e.sent, this._subscriptionService.updateMember(t.member), e.abrupt("return", t);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.deleteMFATOTP = function () {
      return Ee(n, void 0, void 0, fe().mark(function e() {
        var t;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/deleteTOTP",
                errorMessage: "Failed to delete member totp.",
                method: "DELETE"
              });
            case 2:
              return t = e.sent, this._subscriptionService.updateMember(t.member), e.abrupt("return", t);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.deletePassword = function (e) {
      return Ee(n, void 0, void 0, fe().mark(function t() {
        var r;
        return fe().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/passwords/".concat(e),
                errorMessage: "Failed to delete member password.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, this._subscriptionService.updateMember(r.member), t.abrupt("return", r);
            case 5:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    };
  }),
  nt = function () {
    function e(t, r, n, i, o) {
      var s = this,
        a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : Xe();
      be(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._dynamicConfig = i, this._config = o, this.dfpProtectedAuth = a, this.saml = {
        createConnection: function createConnection(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._networkClient.fetchSDK({
                    url: "/b2b/sso/saml",
                    method: "POST",
                    body: e,
                    errorMessage: "Failed to create SAML Connection."
                  });
                case 2:
                  return t.abrupt("return", t.sent);
                case 3:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        updateConnection: function updateConnection(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._networkClient.fetchSDK({
                    url: "/b2b/sso/saml/".concat(e.connection_id),
                    method: "PUT",
                    body: e,
                    errorMessage: "Failed to update SAML Connection."
                  });
                case 2:
                  return t.abrupt("return", t.sent);
                case 3:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        updateConnectionByURL: function updateConnectionByURL(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._networkClient.fetchSDK({
                    url: "/b2b/sso/saml/".concat(e.connection_id, "/url"),
                    method: "PUT",
                    body: e,
                    errorMessage: "Failed to update SAML Connection."
                  });
                case 2:
                  return t.abrupt("return", t.sent);
                case 3:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        deleteVerificationCertificate: function deleteVerificationCertificate(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._networkClient.fetchSDK({
                    url: "/b2b/sso/saml/".concat(e.connection_id, "/verification_certificates/").concat(e.certificate_id),
                    method: "DELETE",
                    errorMessage: "Failed to delete SAML Verification Certificate."
                  });
                case 2:
                  return t.abrupt("return", t.sent);
                case 3:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        }
      }, this.oidc = {
        createConnection: function createConnection(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._networkClient.fetchSDK({
                    url: "/b2b/sso/oidc",
                    method: "POST",
                    body: e,
                    errorMessage: "Failed to create OIDC Connection."
                  });
                case 2:
                  return t.abrupt("return", t.sent);
                case 3:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        updateConnection: function updateConnection(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._networkClient.fetchSDK({
                    url: "/b2b/sso/oidc/".concat(e.connection_id),
                    method: "PUT",
                    body: e,
                    errorMessage: "Failed to update OIDC Connection."
                  });
                case 2:
                  return t.abrupt("return", t.sent);
                case 3:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        }
      };
    }
    return ve(e, [{
      key: "authenticate",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.sso.authenticate").isString("sso_token", e.sso_token).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._pkceManager.getPKPair();
              case 3:
                return (r = t.sent) || We("No code verifier found in local storage for SSO flow.\nConsider using stytch.sso.start() to add PKCE to your SSO flows for added security.\nSee https://stytch.com/docs/oauth#guides_pkce for more information."), t.next = 7, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 7:
                return n = t.sent, i = n.dfp_telemetry_id, o = n.captcha_token, t.t0 = this._networkClient, t.t1 = Object, t.t2 = Object.assign({
                  pkce_code_verifier: null == r ? void 0 : r.code_verifier
                }, e), t.t3 = i, t.t4 = o, t.next = 17, this._subscriptionService.getIntermediateSessionToken();
              case 17:
                if (t.t5 = t.sent, t.t5) {
                  t.next = 20;
                  break;
                }
                t.t5 = void 0;
              case 20:
                return t.t6 = t.t5, t.t7 = {
                  dfp_telemetry_id: t.t3,
                  captcha_token: t.t4,
                  intermediate_session_token: t.t6
                }, t.t8 = t.t1.assign.call(t.t1, t.t2, t.t7), t.t9 = this.dfpProtectedAuth.retryWithCaptchaAndDFP, t.t10 = {
                  url: "/b2b/sso/authenticate",
                  method: "POST",
                  body: t.t8,
                  errorMessage: "Failed to authenticate token",
                  retryCallback: t.t9
                }, t.next = 27, t.t0.retriableFetchSDK.call(t.t0, t.t10);
              case 27:
                return s = t.sent, this._pkceManager.clearPKPair(), s.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member,
                    organization: s.organization
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: s.intermediate_session_token
                }), t.abrupt("return", s);
              case 31:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "getBaseApiUrl",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (!Ve(this._config.publicToken)) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return", this._config.testAPIURL);
              case 2:
                return e.abrupt("return", this._config.liveAPIURL);
              case 3:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "start",
      value: function value(e) {
        var t = e.connection_id,
          r = e.login_redirect_url,
          n = e.signup_redirect_url;
        return Ee(this, void 0, void 0, fe().mark(function e() {
          var i, o, s, a, c;
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._dynamicConfig;
              case 2:
                return i = e.sent, o = i.pkceRequiredForSso, e.next = 6, this.getBaseApiUrl();
              case 6:
                if (s = e.sent, (a = new URL("".concat(s, "/v1/public/sso/start"))).searchParams.set("public_token", this._config.publicToken), a.searchParams.set("connection_id", t), !o) {
                  e.next = 17;
                  break;
                }
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                c = e.sent, a.searchParams.set("pkce_code_challenge", c.code_challenge), e.next = 18;
                break;
              case 17:
                this._pkceManager.clearPKPair();
              case 18:
                r && a.searchParams.set("login_redirect_url", r), n && a.searchParams.set("signup_redirect_url", n), window.location.href = a.toString();
              case 21:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "getConnections",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._networkClient.fetchSDK({
                  url: "/b2b/sso",
                  method: "GET",
                  errorMessage: "Failed to get SSO Connections."
                });
              case 2:
                return e.abrupt("return", e.sent);
              case 3:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "deleteConnection",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/sso/".concat(e),
                  method: "DELETE",
                  errorMessage: "Failed to delete SSO Connection."
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }(),
  it = ve(function e(t, r) {
    var n = this;
    be(this, e), this._networkClient = t, this._subscriptionService = r, this.get = function () {
      return Ee(n, void 0, void 0, fe().mark(function e() {
        var t;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/me",
                errorMessage: "Failed to retrieve organization info.",
                method: "GET"
              });
            case 2:
              return t = e.sent, this._subscriptionService.updateOrganization(t.organization), e.abrupt("return", t.organization);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getSync = function () {
      return n._subscriptionService.getOrganization();
    }, this.getInfo = function () {
      return {
        organization: n.getSync(),
        fromCache: n._subscriptionService.getFromCache()
      };
    }, this.onChange = function (e) {
      return n._subscriptionService.subscribeToState(function (t) {
        var r;
        return e(null !== (r = null == t ? void 0 : t.organization) && void 0 !== r ? r : null);
      });
    }, this.update = function (e) {
      return Ee(n, void 0, void 0, fe().mark(function t() {
        var r;
        return fe().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/me",
                errorMessage: "Failed to update organization info.",
                method: "PUT",
                body: e
              });
            case 2:
              return r = t.sent, t.abrupt("return", r);
            case 4:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this["delete"] = function () {
      return Ee(n, void 0, void 0, fe().mark(function e() {
        var t;
        return fe().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/me",
                errorMessage: "Failed to delete organization.",
                method: "DELETE"
              });
            case 2:
              return t = e.sent, this._subscriptionService.destroyState(), e.abrupt("return", t);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getBySlug = function (e) {
      return Ee(n, void 0, void 0, fe().mark(function t() {
        return fe().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return Je("stytch.organization.getBySlug").isString("organization_slug", e.organization_slug), t.abrupt("return", this._networkClient.fetchSDK({
                url: "/b2b/organizations/search",
                errorMessage: "Failed to get organization by slug.",
                method: "POST",
                body: e
              }));
            case 2:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.members = {
      create: function create(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members",
                  errorMessage: "Failed to create member.",
                  method: "POST",
                  body: e
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      search: function search(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/me/members/search",
                  errorMessage: "Failed to search members.",
                  method: "POST",
                  body: e
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      update: function update(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members/".concat(e.member_id),
                  errorMessage: "Failed to update member.",
                  method: "PUT",
                  body: e
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      deletePassword: function deletePassword(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members/passwords/".concat(e),
                  errorMessage: "Failed to delete member password.",
                  method: "DELETE"
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      deleteMFAPhoneNumber: function deleteMFAPhoneNumber(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members/mfa_phone_numbers/".concat(e),
                  errorMessage: "Failed to delete member MFA Phone number.",
                  method: "DELETE"
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      deleteMFATOTP: function deleteMFATOTP(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members/totp/".concat(e),
                  errorMessage: "Failed to delete member totp.",
                  method: "DELETE"
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      "delete": function _delete(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members/".concat(e),
                  errorMessage: "Failed to delete member.",
                  method: "DELETE"
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      reactivate: function reactivate(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/organizations/members/".concat(e, "/reactivate"),
                  errorMessage: "Failed to reactivate member.",
                  method: "PUT"
                }));
              case 1:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    };
  }),
  ot = function () {
    function e(t, r, n, i, o) {
      var s = this,
        a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : Xe();
      be(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._dynamicConfig = i, this._config = o, this.dfpProtectedAuth = a, this.discovery = {
        authenticate: function authenticate(e) {
          return Ee(s, void 0, void 0, fe().mark(function t() {
            var r, n, i, o, s, a;
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return Je("stytch.oauth.discovery.authenticate").isString("discovery_oauth_token", e.discovery_oauth_token), t.next = 3, this._pkceManager.getPKPair();
                case 3:
                  return r = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 6:
                  return n = t.sent, i = n.dfp_telemetry_id, o = n.captcha_token, s = Object.assign({
                    pkce_code_verifier: null == r ? void 0 : r.code_verifier,
                    dfp_telemetry_id: i,
                    captcha_token: o
                  }, e), t.next = 12, this._networkClient.retriableFetchSDK({
                    url: "/b2b/oauth/discovery/authenticate",
                    body: s,
                    errorMessage: "Failed to authenticate discovery oauth token",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  });
                case 12:
                  return a = t.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                    state: null,
                    session_token: null,
                    session_jwt: null,
                    intermediate_session_token: a.intermediate_session_token
                  }), t.abrupt("return", a);
                case 16:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        }
      }, this.google = {
        start: this.startOAuthFlow(w.Google),
        discovery: {
          start: this.startDiscoveryOAuthFlow(w.Google)
        }
      }, this.microsoft = {
        start: this.startOAuthFlow(w.Microsoft),
        discovery: {
          start: this.startDiscoveryOAuthFlow(w.Microsoft)
        }
      };
    }
    return ve(e, [{
      key: "authenticate",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.oauth.authenticate").isString("oauth_token", e.oauth_token).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._pkceManager.getPKPair();
              case 3:
                return (r = t.sent) || We("No code verifier found in local storage for OAuth flow.\nConsider using stytch.oauth.$provider.start() to add PKCE to your OAuth flows for added security.\nSee https://stytch.com/docs/oauth#guides_pkce for more information."), t.next = 7, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 7:
                return n = t.sent, i = n.dfp_telemetry_id, o = n.captcha_token, t.t0 = this._networkClient, t.t1 = Object, t.t2 = null == r ? void 0 : r.code_verifier, t.t3 = i, t.t4 = o, t.next = 17, this._subscriptionService.getIntermediateSessionToken();
              case 17:
                if (t.t5 = t.sent, t.t5) {
                  t.next = 20;
                  break;
                }
                t.t5 = void 0;
              case 20:
                return t.t6 = t.t5, t.t7 = {
                  pkce_code_verifier: t.t2,
                  dfp_telemetry_id: t.t3,
                  captcha_token: t.t4,
                  intermediate_session_token: t.t6
                }, t.t8 = e, t.t9 = t.t1.assign.call(t.t1, t.t7, t.t8), t.t10 = this.dfpProtectedAuth.retryWithCaptchaAndDFP, t.t11 = {
                  url: "/b2b/oauth/authenticate",
                  method: "POST",
                  body: t.t9,
                  errorMessage: "Failed to authenticate token",
                  retryCallback: t.t10
                }, t.next = 28, t.t0.retriableFetchSDK.call(t.t0, t.t11);
              case 28:
                return s = t.sent, this._pkceManager.clearPKPair(), s.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member,
                    organization: s.organization
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: s.intermediate_session_token
                }), t.abrupt("return", s);
              case 32:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "getBaseApiUrl",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          var t, r;
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._dynamicConfig;
              case 2:
                if (t = e.sent, !(r = t.cnameDomain)) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", "https://".concat(r));
              case 6:
                if (!Ve(this._config.publicToken)) {
                  e.next = 8;
                  break;
                }
                return e.abrupt("return", this._config.testAPIURL);
              case 8:
                return e.abrupt("return", this._config.liveAPIURL);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "startOAuthFlow",
      value: function value(e) {
        var t = this;
        return function (r) {
          var n = r.organization_id,
            i = r.organization_slug,
            o = r.login_redirect_url,
            s = r.signup_redirect_url,
            a = r.custom_scopes,
            c = r.provider_params;
          return Ee(t, void 0, void 0, fe().mark(function t() {
            var r, u, l, d, h, p;
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._dynamicConfig;
                case 2:
                  return r = t.sent, u = r.pkceRequiredForOAuth, t.next = 6, this.getBaseApiUrl();
                case 6:
                  if (l = t.sent, (d = new URL("".concat(l, "/v1/b2b/public/oauth/").concat(e, "/start"))).searchParams.set("public_token", this._config.publicToken), n && "" != n && d.searchParams.set("organization_id", n), i && "" != i && d.searchParams.set("slug", i), a && (Je("startOAuthFlow").isStringArray("custom_scopes", a), d.searchParams.set("custom_scopes", a.join(" "))), c) for (h in Je("startOAuthFlow").isOptionalObject("provider_params", c), c) d.searchParams.set("provider_" + h, c[h]);
                  if (!u) {
                    t.next = 20;
                    break;
                  }
                  return t.next = 16, this._pkceManager.startPKCETransaction();
                case 16:
                  p = t.sent, d.searchParams.set("pkce_code_challenge", p.code_challenge), t.next = 21;
                  break;
                case 20:
                  this._pkceManager.clearPKPair();
                case 21:
                  o && d.searchParams.set("login_redirect_url", o), s && d.searchParams.set("signup_redirect_url", s), window.location.href = d.toString();
                case 24:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        };
      }
    }, {
      key: "startDiscoveryOAuthFlow",
      value: function value(e) {
        var t = this;
        return function (r) {
          var n = r.discovery_redirect_url,
            i = r.custom_scopes,
            o = r.provider_params;
          return Ee(t, void 0, void 0, fe().mark(function t() {
            var r, s, a, c, u, l;
            return fe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._dynamicConfig;
                case 2:
                  return r = t.sent, s = r.pkceRequiredForOAuth, t.next = 6, this.getBaseApiUrl();
                case 6:
                  if (a = t.sent, (c = new URL("".concat(a, "/v1/b2b/public/oauth/").concat(e, "/discovery/start"))).searchParams.set("public_token", this._config.publicToken), i && (Je("startOAuthFlow").isStringArray("custom_scopes", i), c.searchParams.set("custom_scopes", i.join(" "))), o) for (u in Je("startOAuthFlow").isOptionalObject("provider_params", o), o) c.searchParams.set("provider_" + u, o[u]);
                  if (!s) {
                    t.next = 18;
                    break;
                  }
                  return t.next = 14, this._pkceManager.startPKCETransaction();
                case 14:
                  l = t.sent, c.searchParams.set("pkce_code_challenge", l.code_challenge), t.next = 19;
                  break;
                case 18:
                  this._pkceManager.clearPKPair();
                case 19:
                  n && c.searchParams.set("discovery_redirect_url", n), window.location.href = c.toString();
                case 21:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        };
      }
    }]), e;
  }(),
  st = function () {
    function e(t, r) {
      var n = this;
      be(this, e), this._networkClient = t, this._subscriptionService = r, this.getSync = function () {
        return n._subscriptionService.getSession();
      }, this.getInfo = function () {
        return {
          session: n.getSync(),
          fromCache: n._subscriptionService.getFromCache()
        };
      }, this.onChange = function (e) {
        return n._subscriptionService.subscribeToState(function (t) {
          var r;
          return e(null !== (r = null == t ? void 0 : t.session) && void 0 !== r ? r : null);
        });
      }, this.revoke = function (e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, this._networkClient.fetchSDK({
                  url: "/b2b/sessions/revoke",
                  errorMessage: "Error revoking session",
                  method: "POST"
                });
              case 3:
                return r = t.sent, this._subscriptionService.destroyState(), t.abrupt("return", r);
              case 8:
                throw t.prev = 8, t.t0 = t["catch"](0), ((null == e ? void 0 : e.forceClear) || O.includes(t.t0.error_type)) && this._subscriptionService.destroyState(), t.t0;
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 8]]);
        }));
      }, this.authenticate = function (e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r,
            n,
            i,
            o,
            s = this;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return r = this._subscriptionService.getSession(), n = function n() {
                  var e;
                  return (null == r ? void 0 : r.member_session_id) !== (null === (e = s._subscriptionService.getSession()) || void 0 === e ? void 0 : e.member_session_id);
                }, t.prev = 2, i = {
                  session_duration_minutes: null == e ? void 0 : e.session_duration_minutes
                }, t.next = 6, this._networkClient.fetchSDK({
                  url: "/b2b/sessions/authenticate",
                  body: i,
                  errorMessage: "Error authenticating session",
                  method: "POST"
                });
              case 6:
                if (o = t.sent, !n()) {
                  t.next = 9;
                  break;
                }
                return t.abrupt("return", this.authenticate(e));
              case 9:
                return this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.member_session,
                    member: o.member,
                    organization: o.organization
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", o);
              case 13:
                if (t.prev = 13, t.t0 = t["catch"](2), !n()) {
                  t.next = 17;
                  break;
                }
                return t.abrupt("return", this.authenticate(e));
              case 17:
                throw O.includes(t.t0.error_type) && this._subscriptionService.destroySession(), t.t0;
              case 19:
              case "end":
                return t.stop();
            }
          }, t, this, [[2, 13]]);
        }));
      }, this.exchange = function (e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.sessions.exchange").isString("organization_id", e.organization_id).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.prev = 1, t.next = 4, this._networkClient.fetchSDK({
                  url: "/b2b/sessions/exchange",
                  body: e,
                  errorMessage: "Failed to exchange session",
                  method: "POST"
                });
              case 4:
                return (r = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: r.member_session,
                    member: r.member,
                    organization: r.organization
                  },
                  session_token: r.session_token,
                  session_jwt: r.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: r.intermediate_session_token
                }), t.abrupt("return", r);
              case 9:
                throw t.prev = 9, t.t0 = t["catch"](1), t.t0;
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[1, 9]]);
        }));
      };
    }
    return ve(e, [{
      key: "getTokens",
      value: function value() {
        return this._subscriptionService.getTokens();
      }
    }, {
      key: "updateSession",
      value: function value(e) {
        this._subscriptionService.updateTokens(e);
      }
    }]), e;
  }(),
  at = ve(function e(t, r) {
    var n = this;
    be(this, e), this._networkClient = t, this._subscriptionService = r, this.organizations = {
      list: function list() {
        return Ee(n, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.t0 = this._networkClient, e.next = 3, this._subscriptionService.getIntermediateSessionToken();
              case 3:
                if (e.t1 = e.sent, e.t1) {
                  e.next = 6;
                  break;
                }
                e.t1 = void 0;
              case 6:
                return e.t2 = e.t1, e.t3 = {
                  intermediate_session_token: e.t2
                }, e.t4 = {
                  url: "/b2b/discovery/organizations",
                  body: e.t3,
                  errorMessage: "Failed to retrieve discovered organizations",
                  method: "POST"
                }, e.abrupt("return", e.t0.fetchSDK.call(e.t0, e.t4));
              case 10:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      },
      create: function create(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r, n;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.discovery.organizations.create").isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("organization_name", e.organization_name).isOptionalString("organization_slug", e.organization_slug).isOptionalString("organization_logo_url", e.organization_logo_url).isOptionalString("sso_jit_provisioning", e.sso_jit_provisioning).isOptionalStringArray("email_allowed_domains", e.email_allowed_domains).isOptionalString("email_invites", e.email_invites).isOptionalString("auth_methods", e.auth_methods).isOptionalStringArray("allowed_auth_methods", e.allowed_auth_methods).isOptionalString("mfa_policy", e.mfa_policy), t.t0 = Object, t.t1 = Object.assign({}, e), t.next = 5, this._subscriptionService.getIntermediateSessionToken();
              case 5:
                if (t.t2 = t.sent, t.t2) {
                  t.next = 8;
                  break;
                }
                t.t2 = void 0;
              case 8:
                return t.t3 = t.t2, t.t4 = {
                  intermediate_session_token: t.t3
                }, r = t.t0.assign.call(t.t0, t.t1, t.t4), t.next = 13, this._networkClient.fetchSDK({
                  url: "/b2b/discovery/organizations/create",
                  body: r,
                  errorMessage: "Failed to create organization and member",
                  method: "POST"
                });
              case 13:
                return (n = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: n.member_session,
                    member: n.member,
                    organization: n.organization
                  },
                  session_token: n.session_token,
                  session_jwt: n.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: n.intermediate_session_token
                }), t.abrupt("return", n);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, this.intermediateSessions = {
      exchange: function exchange(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r, n;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.discovery.intermediateSessions.exchange").isString("organization_id", e.organization_id).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.t0 = Object, t.t1 = Object.assign({}, e), t.next = 5, this._subscriptionService.getIntermediateSessionToken();
              case 5:
                if (t.t2 = t.sent, t.t2) {
                  t.next = 8;
                  break;
                }
                t.t2 = void 0;
              case 8:
                return t.t3 = t.t2, t.t4 = {
                  intermediate_session_token: t.t3
                }, r = t.t0.assign.call(t.t0, t.t1, t.t4), t.next = 13, this._networkClient.fetchSDK({
                  url: "/b2b/discovery/intermediate_sessions/exchange",
                  body: r,
                  errorMessage: "Failed to exchange intermediate session",
                  method: "POST"
                });
              case 13:
                return (n = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: n.member_session,
                    member: n.member,
                    organization: n.organization
                  },
                  session_token: n.session_token,
                  session_jwt: n.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: n.intermediate_session_token
                }), t.abrupt("return", n);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    };
  }),
  ct = Promise.resolve({
    pkceRequiredForPasswordResets: !1
  }),
  ut = function () {
    function e(t, r, n) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ct,
        o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : Xe();
      be(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._config = i, this.dfpProtectedAuth = o;
    }
    return ve(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          var t, r;
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._config;
              case 2:
                if (t = e.sent, t.pkceRequiredForPasswordResets) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", void 0);
              case 6:
                return e.next = 8, this._pkceManager.getPKPair();
              case 8:
                if (!(r = e.sent)) {
                  e.next = 11;
                  break;
                }
                return e.abrupt("return", r.code_challenge);
              case 11:
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                return r = e.sent, e.abrupt("return", r.code_challenge);
              case 15:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s, a;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.passwords.authenticate").isString("org_id", e.organization_id).isString("password", e.password).isString("email_address", e.email_address).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._pkceManager.getPKPair();
              case 3:
                return r = t.sent, n = null == r ? void 0 : r.code_verifier, t.next = 7, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 7:
                return i = t.sent, o = i.dfp_telemetry_id, s = i.captcha_token, t.t0 = this._networkClient, t.t1 = e.organization_id, t.t2 = e.email_address, t.t3 = e.password, t.t4 = e.session_duration_minutes, t.t5 = e.locale, t.t6 = s, t.t7 = o, t.t8 = n, t.next = 21, this._subscriptionService.getIntermediateSessionToken();
              case 21:
                if (t.t9 = t.sent, t.t9) {
                  t.next = 24;
                  break;
                }
                t.t9 = void 0;
              case 24:
                return t.t10 = t.t9, t.t11 = {
                  organization_id: t.t1,
                  email_address: t.t2,
                  password: t.t3,
                  session_duration_minutes: t.t4,
                  locale: t.t5,
                  captcha_token: t.t6,
                  dfp_telemetry_id: t.t7,
                  code_verifier: t.t8,
                  intermediate_session_token: t.t10
                }, t.t12 = this.dfpProtectedAuth.retryWithCaptchaAndDFP, t.t13 = {
                  url: "/b2b/passwords/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate password.",
                  body: t.t11,
                  retryCallback: t.t12
                }, t.next = 30, t.t0.retriableFetchSDK.call(t.t0, t.t13);
              case 30:
                return (a = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: a.member_session,
                    member: a.member,
                    organization: a.organization
                  },
                  session_token: a.session_token,
                  session_jwt: a.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: a.intermediate_session_token
                }), t.abrupt("return", a);
              case 33:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByEmailStart",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.passwords.resetByEmailStart").isString("email", e.email_address).isOptionalString("login_redirect_url", e.login_redirect_url).isOptionalString("reset_password_redirect_url", e.reset_password_redirect_url).isOptionalString("reset_password_template_id", e.reset_password_template_id).isOptionalNumber("reset_password_expiration_minutes", e.reset_password_expiration_minutes), t.next = 3, this.getCodeChallenge();
              case 3:
                return r = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 6:
                return n = t.sent, i = n.dfp_telemetry_id, o = n.captcha_token, t.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/b2b/passwords/email/reset/start",
                  method: "POST",
                  errorMessage: "Failed to start password reset flow.",
                  body: {
                    organization_id: e.organization_id,
                    email_address: e.email_address,
                    login_redirect_url: e.login_redirect_url,
                    reset_password_redirect_url: e.reset_password_redirect_url,
                    reset_password_expiration_minutes: e.reset_password_expiration_minutes,
                    reset_password_template_id: e.reset_password_template_id,
                    code_challenge: r,
                    captcha_token: o,
                    dfp_telemetry_id: i
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 10:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByEmail",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s, a;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.passwords.resetByEmail").isString("password_reset_token", e.password_reset_token).isString("password", e.password).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._pkceManager.getPKPair();
              case 8:
                return o = t.sent, s = null == o ? void 0 : o.code_verifier, t.t0 = this._networkClient, t.t1 = e.password_reset_token, t.t2 = e.password, t.t3 = e.session_duration_minutes, t.t4 = e.locale, t.t5 = i, t.t6 = n, t.t7 = s, t.next = 20, this._subscriptionService.getIntermediateSessionToken();
              case 20:
                if (t.t8 = t.sent, t.t8) {
                  t.next = 23;
                  break;
                }
                t.t8 = void 0;
              case 23:
                return t.t9 = t.t8, t.t10 = {
                  password_reset_token: t.t1,
                  password: t.t2,
                  session_duration_minutes: t.t3,
                  locale: t.t4,
                  captcha_token: t.t5,
                  dfp_telemetry_id: t.t6,
                  code_verifier: t.t7,
                  intermediate_session_token: t.t9
                }, t.t11 = this.dfpProtectedAuth.retryWithCaptchaAndDFP, t.t12 = {
                  url: "/b2b/passwords/email/reset",
                  method: "POST",
                  errorMessage: "Failed to reset password.",
                  body: t.t10,
                  retryCallback: t.t11
                }, t.next = 29, t.t0.retriableFetchSDK.call(t.t0, t.t12);
              case 29:
                return a = t.sent, this._pkceManager.clearPKPair(), a.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: a.member_session,
                    member: a.member,
                    organization: a.organization
                  },
                  session_token: a.session_token,
                  session_jwt: a.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: a.intermediate_session_token
                }), t.abrupt("return", a);
              case 33:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByExistingPassword",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.passwords.resetByExistingPassword").isString("email", e.email_address).isString("existing_password", e.existing_password).isString("new_password", e.new_password).isOptionalString("locale", e.locale), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/b2b/passwords/existing_password/reset",
                  method: "POST",
                  errorMessage: "Failed to reset password.",
                  body: {
                    organization_id: e.organization_id,
                    email_address: e.email_address,
                    existing_password: e.existing_password,
                    new_password: e.new_password,
                    locale: e.locale,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return (o = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.member_session,
                    member: o.member,
                    organization: o.organization
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: o.intermediate_session_token
                }), t.abrupt("return", o);
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetBySession",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.passwords.resetBySession").isString("password", e.password), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/b2b/passwords/session/reset",
                  method: "POST",
                  errorMessage: "Failed to reset by session.",
                  body: {
                    password: e.password,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.member_session,
                    member: o.member,
                    organization: o.organization
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", o);
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "strengthCheck",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.passwords.strengthCheck").isOptionalString("email", e.email_address).isString("password", e.password), t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/passwords/strength_check",
                  method: "POST",
                  errorMessage: "Failed to check password strength.",
                  body: {
                    email_address: e.email_address,
                    password: e.password
                  }
                }));
              case 2:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }(),
  lt = ve(function e(t, r) {
    var n = this,
      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Xe();
    be(this, e), this._networkClient = t, this._subscriptionService = r, this.dfpProtectedAuth = i, this.sms = {
      send: function send(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r, n, i;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.otps.sms.send").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isOptionalString("mfa_phone_number", e.mfa_phone_number).isOptionalString("locale", e.locale), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.t0 = this._networkClient, t.t1 = Object, t.t2 = Object.assign({}, e), t.t3 = n, t.t4 = i, t.next = 13, this._subscriptionService.getIntermediateSessionToken();
              case 13:
                if (t.t5 = t.sent, t.t5) {
                  t.next = 16;
                  break;
                }
                t.t5 = void 0;
              case 16:
                return t.t6 = t.t5, t.t7 = {
                  dfp_telemetry_id: t.t3,
                  captcha_token: t.t4,
                  intermediate_session_token: t.t6
                }, t.t8 = t.t1.assign.call(t.t1, t.t2, t.t7), t.t9 = this.dfpProtectedAuth.retryWithCaptchaAndDFP, t.t10 = {
                  url: "/b2b/otps/sms/send",
                  body: t.t8,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: t.t9
                }, t.abrupt("return", t.t0.retriableFetchSDK.call(t.t0, t.t10));
              case 22:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      authenticate: function authenticate(e) {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.otps.sms.authenticate").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isString("code", e.code).isOptionalString("set_mfa_enrollment", e.set_mfa_enrollment), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.t0 = Object, t.t1 = Object.assign({}, e), t.t2 = n, t.t3 = i, t.next = 12, this._subscriptionService.getIntermediateSessionToken();
              case 12:
                if (t.t4 = t.sent, t.t4) {
                  t.next = 15;
                  break;
                }
                t.t4 = void 0;
              case 15:
                return t.t5 = t.t4, t.t6 = {
                  dfp_telemetry_id: t.t2,
                  captcha_token: t.t3,
                  intermediate_session_token: t.t5
                }, o = t.t0.assign.call(t.t0, t.t1, t.t6), t.next = 20, this._networkClient.retriableFetchSDK({
                  url: "/b2b/otps/sms/authenticate",
                  body: o,
                  errorMessage: "Failed to authenticate one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 20:
                return s = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member,
                    organization: s.organization
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", s);
              case 23:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    };
  }),
  dt = function () {
    function e(t, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Xe();
      be(this, e), this._networkClient = t, this._subscriptionService = r, this.dfpProtectedAuth = n;
    }
    return ve(e, [{
      key: "create",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.totp.create").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isOptionalNumber("expiration_minutes", e.expiration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.t0 = this._networkClient, t.t1 = Object, t.t2 = Object.assign({}, e), t.t3 = n, t.t4 = i, t.next = 13, this._subscriptionService.getIntermediateSessionToken();
              case 13:
                if (t.t5 = t.sent, t.t5) {
                  t.next = 16;
                  break;
                }
                t.t5 = void 0;
              case 16:
                return t.t6 = t.t5, t.t7 = {
                  dfp_telemetry_id: t.t3,
                  captcha_token: t.t4,
                  intermediate_session_token: t.t6
                }, t.t8 = t.t1.assign.call(t.t1, t.t2, t.t7), t.t9 = this.dfpProtectedAuth.retryWithCaptchaAndDFP, t.t10 = {
                  url: "/b2b/totp",
                  body: t.t8,
                  errorMessage: "Failed to create TOTP",
                  method: "POST",
                  retryCallback: t.t9
                }, t.abrupt("return", t.t0.retriableFetchSDK.call(t.t0, t.t10));
              case 22:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.totp.authenticate").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isString("code", e.code).isOptionalString("set_mfa_enrollment", e.set_mfa_enrollment).isOptionalBoolean("set_default_mfa", e.set_default_mfa), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.t0 = Object, t.t1 = Object.assign({}, e), t.t2 = n, t.t3 = i, t.next = 12, this._subscriptionService.getIntermediateSessionToken();
              case 12:
                if (t.t4 = t.sent, t.t4) {
                  t.next = 15;
                  break;
                }
                t.t4 = void 0;
              case 15:
                return t.t5 = t.t4, t.t6 = {
                  dfp_telemetry_id: t.t2,
                  captcha_token: t.t3,
                  intermediate_session_token: t.t5
                }, o = t.t0.assign.call(t.t0, t.t1, t.t6), t.next = 20, this._networkClient.retriableFetchSDK({
                  url: "/b2b/totp/authenticate",
                  body: o,
                  errorMessage: "Failed to authenticate TOTP",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 20:
                return s = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member,
                    organization: s.organization
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", s);
              case 23:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }(),
  ht = function () {
    function e(t, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Xe();
      be(this, e), this._networkClient = t, this._subscriptionService = r, this.dfpProtectedAuth = n;
    }
    return ve(e, [{
      key: "recover",
      value: function value(e) {
        return Ee(this, void 0, void 0, fe().mark(function t() {
          var r, n, i, o, s;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return Je("stytch.recoveryCodes.recover").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isString("recovery_code", e.recovery_code), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.t0 = Object, t.t1 = Object.assign({}, e), t.t2 = n, t.t3 = i, t.next = 12, this._subscriptionService.getIntermediateSessionToken();
              case 12:
                if (t.t4 = t.sent, t.t4) {
                  t.next = 15;
                  break;
                }
                t.t4 = void 0;
              case 15:
                return t.t5 = t.t4, t.t6 = {
                  dfp_telemetry_id: t.t2,
                  captcha_token: t.t3,
                  intermediate_session_token: t.t5
                }, o = t.t0.assign.call(t.t0, t.t1, t.t6), t.next = 20, this._networkClient.retriableFetchSDK({
                  url: "/b2b/recovery_codes/recover",
                  body: o,
                  errorMessage: "Failed to recover using recovery code",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 20:
                return s = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member,
                    organization: s.organization
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", s);
              case 23:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "rotate",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          var t, r, n;
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return t = e.sent, r = t.dfp_telemetry_id, n = t.captcha_token, e.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/b2b/recovery_codes/rotate",
                  body: {
                    dfp_telemetry_id: r,
                    captcha_token: n
                  },
                  errorMessage: "Failed to rotate recovery codes",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 6:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "get",
      value: function value() {
        return Ee(this, void 0, void 0, fe().mark(function e() {
          return fe().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this._networkClient.fetchSDK({
                  url: "/b2b/recovery_codes",
                  errorMessage: "Failed to get recovery codes",
                  method: "GET"
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }]), e;
  }(),
  pt = function () {
    function e(t, r, n) {
      var i = this;
      be(this, e), this._subscriptionService = n, this.isAuthorizedSync = function (e, t) {
        var r;
        return !!(null === (r = i.cachedPolicy) || void 0 === r ? void 0 : r.callerIsAuthorized(i.roleIds(), e, t));
      }, this.isAuthorized = function (e, t) {
        return i.policyPromise.then(function (r) {
          return r.callerIsAuthorized(i.roleIds(), e, t);
        });
      }, this.cachedPolicy = t.rbacPolicy ? xt.fromJSON(t.rbacPolicy) : null, this.policyPromise = r.then(function (e) {
        return e.rbacPolicy ? (i.cachedPolicy = xt.fromJSON(e.rbacPolicy), i.cachedPolicy) : (He("Unable to retrieve RBAC policy from servers. Assuming caller has no permissions."), new xt([], []));
      });
    }
    return ve(e, [{
      key: "allPermissions",
      value: function value() {
        var e = this;
        return this.policyPromise.then(function (t) {
          return t.allPermissionsForCaller(e.roleIds());
        });
      }
    }, {
      key: "roleIds",
      value: function value() {
        var e,
          t = this._subscriptionService.getSession();
        return t && null !== (e = t.roles) && void 0 !== e ? e : [];
      }
    }]), e;
  }(),
  _t = function () {
    function e(t) {
      be(this, e), this.iframeURL = t, this.createIframe();
    }
    return ve(e, [{
      key: "createIframe",
      value: function value() {
        var e = document.querySelector('[src~="'.concat(this.iframeURL, '"]'));
        e ? We("It looks like you're creating multiple copies of the Stytch client. This behavior is unsupported, and unintended side effects may occur. Make sure you are creating the Stytch client at the global level, and not inside a component's render function.") : ((e = document.createElement("iframe")).src = this.iframeURL, e.style.position = "absolute", e.style.width = "0", e.style.height = "0", e.style.border = "0", document.body.appendChild(e)), "true" !== e.dataset.loaded ? this.frame = new Promise(function (t) {
          e.addEventListener("load", function () {
            e.dataset.loaded = "true", t(e);
          }, {
            once: !0
          });
        }) : this.frame = Promise.resolve(e);
      }
    }, {
      key: "call",
      value: function value(e, t) {
        return Ee(this, void 0, void 0, fe().mark(function r() {
          var n,
            i,
            o = this;
          return fe().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.frame;
              case 2:
                return n = r.sent, i = new MessageChannel(), r.abrupt("return", new Promise(function (r, s) {
                  var a;
                  i.port1.onmessage = function (e) {
                    var t = e.data;
                    i.port1.close(), t.success ? r(t.payload) : s(Ze.unmarshall(t.error));
                  };
                  var c = {
                    method: e,
                    args: t
                  };
                  null === (a = n.contentWindow) || void 0 === a || a.postMessage(c, o.iframeURL, [i.port2]);
                }));
              case 5:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }]), e;
  }(),
  ft = function () {
    function e(t, r) {
      be(this, e), this._networkClient = t, this.dfpProtectedAuth = r;
    }
    return ve(e, [{
      key: "searchUser",
      value: function value(e) {
        var t = this;
        return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha().then(function (r) {
          var n = r.dfp_telemetry_id,
            i = r.captcha_token;
          return t._networkClient.fetchSDK({
            url: "/users/search",
            method: "POST",
            body: {
              email: e,
              dfp_telemetry_id: n,
              captcha_token: i
            },
            errorMessage: "Error searching for user ".concat(e)
          });
        });
      }
    }, {
      key: "searchMember",
      value: function value(e, t) {
        return this._networkClient.fetchSDK({
          url: "/b2b/organizations/members/search",
          method: "POST",
          body: {
            email_address: e,
            organization_id: t
          },
          errorMessage: "Error searching for member ".concat(e)
        });
      }
    }]), e;
  }(),
  mt = function () {
    function e(t, r) {
      var n = this;
      be(this, e), this._subscriptionService = t, this._headlessSessionClient = r, this._onDataChange = function (e) {
        !function (e) {
          return !!(null == e ? void 0 : e.session);
        }(e) ? n.cancelBackgroundRefresh() : n.scheduleBackgroundRefresh();
      }, this._reauthenticateWithBackoff = function () {
        return Ee(n, void 0, void 0, fe().mark(function t() {
          var r;
          return fe().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                r = 0;
              case 1:
                return t.prev = 2, t.next = 5, this._headlessSessionClient.authenticate();
              case 5:
                return t.abrupt("return", t.sent);
              case 8:
                if (t.prev = 8, t.t0 = t["catch"](2), !e.isUnrecoverableError(t.t0)) {
                  t.next = 12;
                  break;
                }
                return t.abrupt("return", Promise.reject(t.t0));
              case 12:
                return r++, t.next = 15, new Promise(function (t) {
                  return setTimeout(t, e.timeoutForAttempt(r));
                });
              case 15:
                t.next = 1;
                break;
              case 17:
              case "end":
                return t.stop();
            }
          }, t, this, [[2, 8]]);
        }));
      }, this.timeout = null, this._subscriptionService.subscribeToState(this._onDataChange);
    }
    return ve(e, [{
      key: "performBackgroundRefresh",
      value: function value() {
        var e = this;
        this._reauthenticateWithBackoff().then(function () {
          e.scheduleBackgroundRefresh();
        })["catch"](function (t) {
          We("Session background refresh failed. Signalling to app that user is logged out.", {
            error: t
          }), e._subscriptionService.destroySession();
        });
      }
    }, {
      key: "scheduleBackgroundRefresh",
      value: function value() {
        var t = this;
        this.cancelBackgroundRefresh(), this.timeout = setTimeout(function () {
          t.performBackgroundRefresh();
        }, e.REFRESH_INTERVAL_MS);
      }
    }, {
      key: "cancelBackgroundRefresh",
      value: function value() {
        null !== this.timeout && (clearTimeout(this.timeout), this.timeout = null);
      }
    }], [{
      key: "timeoutForAttempt",
      value: function value(e) {
        return e = Math.min(e, 7), Math.floor(350 * Math.random()) - 175 + 2e3 * Math.pow(2, e);
      }
    }, {
      key: "isUnrecoverableError",
      value: function value(e) {
        return O.includes(e.error_type);
      }
    }]), e;
  }();
mt.REFRESH_INTERVAL_MS = 18e4;
var vt,
  gt,
  bt,
  yt,
  kt,
  wt,
  St,
  Tt,
  Ct,
  Pt,
  Ot,
  Et,
  At = ve(function e(t, r) {
    var n = this;
    be(this, e), this._subscriptionService = t, this.emptyState = r, this.onStateChange = function (e) {
      return n._subscriptionService.subscribeToState(function (t) {
        e(null != t ? t : n.emptyState);
      });
    };
  }),
  xt = function () {
    function e(t, r) {
      var n = this;
      be(this, e), this.roles = t, this.resources = r, this.rolesByID = {}, t.forEach(function (e) {
        return n.rolesByID[e.role_id] = e;
      });
    }
    return ve(e, [{
      key: "callerIsAuthorized",
      value: function value(e, t, r) {
        var n = this;
        return !!e.map(function (e) {
          return n.rolesByID[e];
        }).filter(function (e) {
          return e;
        }).flatMap(function (e) {
          return e.permissions;
        }).filter(function (e) {
          return e.resource_id === t;
        }).find(function (e) {
          return e.actions.includes(r) || e.actions.includes("*");
        });
      }
    }, {
      key: "allPermissionsForCaller",
      value: function value(e) {
        var t = this,
          r = {};
        return this.resources.forEach(function (n) {
          r[n.resource_id] = {}, n.actions.forEach(function (i) {
            r[n.resource_id][i] = t.callerIsAuthorized(e, n.resource_id, i);
          });
        }), r;
      }
    }], [{
      key: "fromJSON",
      value: function value(t) {
        return new e(t.roles, t.resources);
      }
    }]), e;
  }();
function Dt(e, t, r, n) {
  return new (r || (r = Promise))(function (i, o) {
    function s(e) {
      try {
        c(n.next(e));
      } catch (e) {
        o(e);
      }
    }
    function a(e) {
      try {
        c(n["throw"](e));
      } catch (e) {
        o(e);
      }
    }
    function c(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(s, a);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function Rt(e, t, r, n) {
  return new (r || (r = Promise))(function (i, o) {
    function s(e) {
      try {
        c(n.next(e));
      } catch (e) {
        o(e);
      }
    }
    function a(e) {
      try {
        c(n["throw"](e));
      } catch (e) {
        o(e);
      }
    }
    function c(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(s, a);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError, "function" == typeof SuppressedError && SuppressedError, function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(vt || (vt = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(gt || (gt = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(bt || (bt = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating", e.embeddedOnly = "embeddedOnly", e.floatingOrEmbedded = "floatingOrEmbedded", e.forceLegacyEmbedded = "forceLegacyEmbedded";
}(yt || (yt = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(kt || (kt = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_OAUTH_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION", e.B2BSMSOTPSend = "B2B_SMS_OTP_SEND", e.B2BSMSOTPAuthenticate = "B2B_SMS_OTP_AUTHENTICATE", e.B2BTOTPCreate = "B2B_TOTP_CREATE", e.B2BTOTPAuthenticate = "B2B_TOTP_AUTHENTICATE", e.B2BRecoveryCodesRecover = "B2B_RECOVERY_CODES_RECOVER";
}(wt || (wt = {})), function (e) {
  e[e.emailMagicLinks = 0] = "emailMagicLinks", e[e.oauth = 1] = "oauth", e[e.otp = 2] = "otp", e[e.passwords = 3] = "passwords";
}(St || (St = {})), function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(Tt || (Tt = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(Ct || (Ct = {})), function (e) {
  e.smsOtp = "smsOtp", e.totp = "totp";
}(Pt || (Pt = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(Ot || (Ot = {})), function (e) {
  e.RequiredCatcha = "Catcha Required";
}(Et || (Et = {}));
var It;
!function (e) {
  e.LoginOrCreateEML = "login_or_create_eml", e.LoginOrCreateOTP = "login_or_create_otp", e.ResetPassword = "reset_password";
}(It || (It = {})), Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
}), Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var Bt = /*#__PURE__*/function (_ot) {
  _inherits(Bt, _ot);
  function Bt(e, t, r, n, i) {
    var _this;
    var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {
      return {
        isEnabled: function isEnabled() {
          return Rt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", !1);
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
        },
        getTelemetryID: function getTelemetryID() {
          return Rt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
        },
        getDFPTelemetryIDAndCaptcha: function getDFPTelemetryIDAndCaptcha() {
          return Rt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", {
                    dfp_telemetry_id: void 0,
                    captcha_token: void 0
                  });
                case 1:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
        },
        retryWithCaptchaAndDFP: function retryWithCaptchaAndDFP() {
          return Rt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  throw new Error("DFP protected auth is disabled");
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
        }
      };
    }();
    var s = arguments.length > 6 ? arguments[6] : undefined;
    _classCallCheck(this, Bt);
    _this = _callSuper(this, Bt, [e, t, r, n, i, o]), _this._oneTap = s, _this.startOneTapDiscovery = function (e) {
      return Dt(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var t, r, n;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this._oneTap.createOneTapClient();
            case 2:
              t = _context5.sent;
              if (t.success) {
                _context5.next = 5;
                break;
              }
              throw new Error("One Tap could not load: ".concat(t.reason));
            case 5:
              r = t.client, n = this._oneTap.createOnDiscoverySuccessHandler({
                discoveryRedirectUrl: e.discovery_redirect_url,
                onSuccess: this._oneTap.RedirectOnSuccess
              });
              return _context5.abrupt("return", r.render({
                style: {
                  position: f.floating
                },
                callback: n
              }));
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }, _this.startOneTap = function (e) {
      return Dt(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var t, r, n;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (e.organization_id) {
                _context6.next = 2;
                break;
              }
              throw new T("stytch.oauth.googleOneTap.start", "organization_id is a required argument");
            case 2:
              _context6.next = 4;
              return this._oneTap.createOneTapClient();
            case 4:
              t = _context6.sent;
              if (t.success) {
                _context6.next = 7;
                break;
              }
              throw new Error("One Tap could not load: ".concat(t.reason));
            case 7:
              r = t.client, n = this._oneTap.createOnSuccessHandler({
                organizationId: e.organization_id,
                signupRedirectUrl: e.signup_redirect_url,
                loginRedirectUrl: e.login_redirect_url,
                onSuccess: this._oneTap.RedirectOnSuccess
              });
              return _context6.abrupt("return", r.render({
                style: {
                  position: f.floating
                },
                callback: n
              }));
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }, _this.googleOneTap = {
      discovery: {
        start: _this.startOneTapDiscovery
      },
      start: _this.startOneTap
    };
    return _this;
  }
  return _createClass(Bt);
}(ot);
var Lt = "bootstrap";
var Mt = /*#__PURE__*/function () {
  function Mt(e, t, r) {
    var _this2 = this;
    _classCallCheck(this, Mt);
    this._publicToken = e, this._networkClient = t, this._dataLayer = r, this._bootstrapDataPromise = this._networkClient.fetchSDK({
      url: "/projects/bootstrap/".concat(this._publicToken),
      method: "GET",
      errorMessage: "Error fetching bootstrap data for SDK for ".concat(this._publicToken)
    }).then(Mt.mapBootstrapData).then(function (e) {
      return _this2._dataLayer.setItem(Lt, JSON.stringify(e)), e;
    })["catch"](function (e) {
      return He(e), {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1,
        rbacPolicy: null
      };
    });
  }
  _createClass(Mt, [{
    key: "getSync",
    value: function getSync() {
      var e = this._dataLayer.getItem(Lt);
      if (null === e) return {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1,
        rbacPolicy: null
      };
      try {
        return JSON.parse(e);
      } catch (e) {
        return {
          displayWatermark: !1,
          cnameDomain: null,
          emailDomains: ["stytch.com"],
          captchaSettings: {
            enabled: !1
          },
          pkceRequiredForEmailMagicLinks: !1,
          pkceRequiredForPasswordResets: !1,
          pkceRequiredForOAuth: !1,
          pkceRequiredForSso: !1,
          slugPattern: null,
          createOrganizationEnabled: !1,
          passwordConfig: null,
          runDFPProtectedAuth: !1,
          rbacPolicy: null
        };
      }
    }
  }, {
    key: "getAsync",
    value: function getAsync() {
      return this._bootstrapDataPromise;
    }
  }], [{
    key: "mapBootstrapData",
    value: function mapBootstrapData(e) {
      var t, r;
      var n = null !== e.password_config ? {
        ludsComplexity: e.password_config.luds_complexity,
        ludsMinimumCount: e.password_config.luds_minimum_count
      } : null;
      return {
        displayWatermark: !e.disable_sdk_watermark,
        captchaSettings: e.captcha_settings,
        cnameDomain: e.cname_domain,
        emailDomains: e.email_domains,
        pkceRequiredForEmailMagicLinks: e.pkce_required_for_email_magic_links,
        pkceRequiredForPasswordResets: e.pkce_required_for_password_resets,
        pkceRequiredForOAuth: e.pkce_required_for_oauth,
        pkceRequiredForSso: e.pkce_required_for_sso,
        slugPattern: e.slug_pattern,
        createOrganizationEnabled: e.create_organization_enabled,
        passwordConfig: n,
        runDFPProtectedAuth: null !== (t = e.dfp_protected_auth_enabled) && void 0 !== t && t,
        dfpProtectedAuthMode: e.dfp_protected_auth_mode,
        rbacPolicy: null !== (r = e.rbac_policy) && void 0 !== r ? r : null
      };
    }
  }]);
  return Mt;
}();
var Ft = /*#__PURE__*/_createClass(function Ft(e) {
  var _this3 = this;
  _classCallCheck(this, Ft);
  this.bootstrapPromise = e, this.executeRecaptcha = function () {
    return Dt(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var _yield$this$state, e, t, r;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return this.state;
          case 2:
            _yield$this$state = _context7.sent;
            e = _yield$this$state.captchaClient;
            t = _yield$this$state.configured;
            r = _yield$this$state.siteKey;
            if (!t) {
              _context7.next = 10;
              break;
            }
            _context7.next = 9;
            return new Promise(function (t) {
              return e.ready(t);
            });
          case 9:
            return _context7.abrupt("return", e.execute(r, {
              action: "LOGIN"
            }));
          case 10:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
  }, this.state = e.then(function (e) {
    return Dt(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var t;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!e.captchaSettings.enabled) {
              _context8.next = 9;
              break;
            }
            _context8.t1 = !0;
            _context8.next = 4;
            return t = e.captchaSettings.siteKey, Ke("https://www.google.com/recaptcha/enterprise.js?render=".concat(t), function () {
              return window.grecaptcha.enterprise;
            });
          case 4:
            _context8.t2 = _context8.sent;
            _context8.t3 = e.captchaSettings.siteKey;
            _context8.t0 = {
              configured: _context8.t1,
              captchaClient: _context8.t2,
              siteKey: _context8.t3
            };
            _context8.next = 10;
            break;
          case 9:
            _context8.t0 = {
              configured: !1
            };
          case 10:
            return _context8.abrupt("return", _context8.t0);
          case 11:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  });
});
var jt = /*#__PURE__*/function () {
  function jt(e) {
    var _this4 = this;
    _classCallCheck(this, jt);
    this.iframeURL = e, this.oneTapStart = function (e) {
      return _this4.call("oneTapStart", e);
    }, this.oneTapSubmit = function (e) {
      return _this4.call("oneTapSubmit", e);
    }, this.parsedPhoneNumber = function (e) {
      return _this4.call("parsedPhoneNumber", e);
    };
  }
  _createClass(jt, [{
    key: "frameClient",
    get: function get() {
      var e;
      return this._frameClient = null !== (e = this._frameClient) && void 0 !== e ? e : new _t(this.iframeURL), this._frameClient;
    }
  }, {
    key: "call",
    value: function call(e, t) {
      return this.frameClient.call(e, [t]);
    }
  }]);
  return jt;
}();
var Nt = /*#__PURE__*/function () {
  function Nt(e, t, r, n) {
    _classCallCheck(this, Nt);
    this._publicToken = e, this._subscriptionDataLayer = t, this.baseURL = r, this.additionalTelemetryDataFn = n, this.updateSessionToken = function () {
      return null;
    }, this.eventLogger = new Qe({
      maxBatchSize: 15,
      intervalDurationMs: 800,
      logEventURL: this.buildSDKUrl("/events")
    });
  }
  _createClass(Nt, [{
    key: "logEvent",
    value: function logEvent(_ref) {
      var e = _ref.name,
        t = _ref.details,
        _ref$error = _ref.error,
        r = _ref$error === void 0 ? {} : _ref$error;
      this.eventLogger.logEvent(this.createTelemetryBlob(), {
        public_token: this._publicToken,
        event_name: e,
        details: t,
        error_code: r.error_code,
        error_description: r.error_description,
        http_status_code: r.http_status_code
      });
    }
  }, {
    key: "createTelemetryBlob",
    value: function createTelemetryBlob() {
      return Object.assign(Object.assign({
        event_id: "event-id-".concat(je()),
        app_session_id: "app-session-id-".concat(je()),
        persistent_id: "persistent-id-".concat(je()),
        client_sent_at: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }, this.additionalTelemetryDataFn()), {
        app: {
          identifier: window.location.hostname
        },
        sdk: {
          identifier: "Stytch.js Javascript SDK",
          version: "4.11.0"
        }
      });
    }
  }, {
    key: "fetchSDK",
    value: function fetchSDK(_ref2) {
      var e = _ref2.url,
        t = _ref2.body,
        r = _ref2.errorMessage,
        n = _ref2.method;
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var i, o, s, a;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              i = this._subscriptionDataLayer.readSessionCookie().session_token, o = "Basic " + window.btoa(this._publicToken + ":" + (i || this._publicToken)), s = window.btoa(JSON.stringify(this.createTelemetryBlob())), a = window.location.origin;
              return _context9.abrupt("return", De({
                basicAuthHeader: o,
                body: t,
                errorMessage: r,
                finalURL: this.buildSDKUrl(e),
                method: n,
                xSDKClientHeader: s,
                xSDKParentHostHeader: a
              }));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "retriableFetchSDK",
    value: function retriableFetchSDK(_ref3) {
      var e = _ref3.url,
        t = _ref3.body,
        r = _ref3.errorMessage,
        n = _ref3.method,
        i = _ref3.retryCallback;
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var o, s, a, c;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              o = this._subscriptionDataLayer.readSessionCookie().session_token, s = "Basic " + window.btoa(this._publicToken + ":" + (o || this._publicToken)), a = window.btoa(JSON.stringify(this.createTelemetryBlob())), c = window.location.origin;
              return _context10.abrupt("return", function (e) {
                var t = e.method,
                  r = e.errorMessage,
                  n = e.finalURL,
                  i = e.basicAuthHeader,
                  o = e.xSDKClientHeader,
                  s = e.xSDKParentHostHeader,
                  a = e.body,
                  c = e.retryCallback;
                return Ee(this, void 0, void 0, fe().mark(function e() {
                  var u;
                  return fe().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return u = {
                          method: t,
                          errorMessage: r,
                          finalURL: n,
                          basicAuthHeader: i,
                          xSDKClientHeader: o,
                          xSDKParentHostHeader: s,
                          body: a
                        }, e.prev = 1, e.next = 4, De(u);
                      case 4:
                      case 15:
                        return e.abrupt("return", e.sent);
                      case 7:
                        if (e.prev = 7, e.t0 = e["catch"](1), !(e.t0 instanceof xe)) {
                          e.next = 16;
                          break;
                        }
                        return e.next = 12, c(e.t0, u);
                      case 12:
                        return u = e.sent, e.next = 15, De(u);
                      case 16:
                        throw e.t0;
                      case 17:
                      case "end":
                        return e.stop();
                    }
                  }, e, null, [[1, 7]]);
                }));
              }({
                basicAuthHeader: s,
                body: t,
                errorMessage: r,
                finalURL: this.buildSDKUrl(e),
                method: n,
                xSDKClientHeader: a,
                xSDKParentHostHeader: c,
                retryCallback: i
              }));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "buildSDKUrl",
    value: function buildSDKUrl(e) {
      return "".concat(this.baseURL, "/sdk/v1").concat(e);
    }
  }]);
  return Nt;
}();
function Kt(e) {
  var t = e.toString(16);
  return 1 === t.length && (t = "0" + t), t;
}
var Ut = /*#__PURE__*/function () {
  function Ut(e, t) {
    _classCallCheck(this, Ut);
    this._dataLayer = e, this.namespace = t;
  }
  _createClass(Ut, [{
    key: "key",
    value: function key() {
      return "PKCE_VERIFIER:" + this.namespace;
    }
  }, {
    key: "startPKCETransaction",
    value: function startPKCETransaction() {
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var e;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return Ut.createProofkeyPair();
            case 2:
              e = _context11.sent;
              return _context11.abrupt("return", (this._dataLayer.setItem(this.key(), JSON.stringify(e)), e));
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getPKPair",
    value: function getPKPair() {
      var e = this._dataLayer.getItem(this.key());
      if (null !== e) try {
        return JSON.parse(e);
      } catch (e) {
        return void We("Found malformed Proof Key pair in localstorage.");
      }
    }
  }, {
    key: "clearPKPair",
    value: function clearPKPair() {
      return this._dataLayer.removeItem(this.key());
    }
  }], [{
    key: "createProofkeyPair",
    value: function createProofkeyPair() {
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _String$fromCharCode;
        var e, t, r, n;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              e = new Uint32Array(16);
              window.crypto.getRandomValues(e);
              t = Array.from(e).map(Kt).join("");
              _context12.next = 5;
              return window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(t));
            case 5:
              r = _context12.sent;
              return _context12.abrupt("return", {
                code_challenge: (n = r, btoa((_String$fromCharCode = String.fromCharCode).call.apply(_String$fromCharCode, [null].concat(_toConsumableArray(new Uint8Array(n))))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")),
                code_verifier: t
              });
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
    }
  }]);
  return Ut;
}();
var zt = function zt(e) {
  return (document.cookie ? document.cookie.split("; ") : []).filter(function (t) {
    var _t$split = t.split("="),
      _t$split2 = _slicedToArray(_t$split, 1),
      r = _t$split2[0];
    return e === r;
  }).length > 1;
};
/*! js-cookie v3.0.1 | MIT */
function qt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r) e[n] = r[n];
  }
  return e;
}
var Gt = function e(t, r) {
  function n(e, n, i) {
    if ("undefined" != typeof document) {
      "number" == typeof (i = qt({}, r, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e = encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var o = "";
      for (var s in i) i[s] && (o += "; " + s, !0 !== i[s] && (o += "=" + i[s].split(";")[0]));
      return document.cookie = e + "=" + t.write(n, e) + o;
    }
  }
  return Object.create({
    set: n,
    get: function get(e) {
      if ("undefined" != typeof document && (!arguments.length || e)) {
        for (var r = document.cookie ? document.cookie.split("; ") : [], n = {}, i = 0; i < r.length; i++) {
          var o = r[i].split("="),
            s = o.slice(1).join("=");
          try {
            var a = decodeURIComponent(o[0]);
            if (n[a] = t.read(s, a), e === a) break;
          } catch (e) {}
        }
        return e ? n[e] : n;
      }
    },
    remove: function remove(e, t) {
      n(e, "", qt({}, t, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(t) {
      return e(this.converter, qt({}, this.attributes, t));
    },
    withConverter: function withConverter(t) {
      return e(qt({}, this.converter, t), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(r)
    },
    converter: {
      value: Object.freeze(t)
    }
  });
}({
  read: function read(e) {
    return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
}, {
  path: "/"
});
var Wt = function Wt(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return "stytch_sdk_state_".concat(e).concat(t ? "::".concat(t) : "");
  },
  Ht = new Map(),
  Yt = function Yt(e) {
    clearTimeout(Ht.get(e));
  },
  Vt = function Vt(e, t, r) {
    Yt(e);
    var n = setTimeout(function () {
      void 0 === Gt.get(e) && Gt.set(e, t, r);
    }, 10);
    return Ht.set(e, n), Gt.set(e, t, r);
  };
var Jt = /*#__PURE__*/function () {
  function Jt(e, t) {
    var _this5 = this;
    _classCallCheck(this, Jt);
    this.browserSessionStorage = {
      getItem: function getItem(e) {
        return sessionStorage.getItem(Wt(_this5.publicToken, e));
      },
      setItem: function setItem(e, t) {
        return sessionStorage.setItem(Wt(_this5.publicToken, e), t);
      },
      removeItem: function removeItem(e) {
        return sessionStorage.removeItem(Wt(_this5.publicToken, e));
      }
    }, this.publicToken = e, this.state = null, this.stateKeysUpdated = new Set(), this.subscriptions = {}, (null == t ? void 0 : t.cookieOptions) ? (Je("SubscriptionDataLayer").isOptionalString("cookieOptions.opaqueTokenCookieName", t.cookieOptions.opaqueTokenCookieName).isOptionalString("cookieOptions.jwtCookieName", t.cookieOptions.jwtCookieName).isOptionalString("cookieOptions.istCookieName", t.cookieOptions.istCookieName).isOptionalString("cookieOptions.path", t.cookieOptions.path).isOptionalString("cookieOptions.domain", t.cookieOptions.domain), this._jwtCookieName = t.cookieOptions.jwtCookieName || null, this._opaqueTokenCookieName = t.cookieOptions.opaqueTokenCookieName || null, this._cookiePath = t.cookieOptions.path || null, this._domain = t.cookieOptions.domain || null, this._cookieAvailableToSubdomains = t.cookieOptions.availableToSubdomains || !1, this._istCookieName = t.cookieOptions.istCookieName || null) : (this._opaqueTokenCookieName = null, this._jwtCookieName = null, this._cookiePath = null, this._domain = null, this._cookieAvailableToSubdomains = !1, this._istCookieName = null);
    var r = localStorage.getItem(Wt(this.publicToken));
    if (!r) return;
    var n;
    try {
      n = JSON.parse(r);
    } catch (e) {
      return void this.syncToLocalStorage();
    }
    this.state = n;
  }
  _createClass(Jt, [{
    key: "opaqueTokenCookieName",
    get: function get() {
      var e;
      return null !== (e = this._opaqueTokenCookieName) && void 0 !== e ? e : "stytch_session";
    }
  }, {
    key: "jwtCookieName",
    get: function get() {
      var e;
      return null !== (e = this._jwtCookieName) && void 0 !== e ? e : "stytch_session_jwt";
    }
  }, {
    key: "istCookieName",
    get: function get() {
      var e;
      return null !== (e = this._istCookieName) && void 0 !== e ? e : "stytch_intermediate_session_token";
    }
  }, {
    key: "readSessionCookie",
    value: function readSessionCookie() {
      return {
        session_token: Gt.get(this.opaqueTokenCookieName),
        session_jwt: Gt.get(this.jwtCookieName)
      };
    }
  }, {
    key: "readIntermediateSessionTokenCookie",
    value: function readIntermediateSessionTokenCookie() {
      return Gt.get(this.istCookieName);
    }
  }, {
    key: "writeSessionCookie",
    value: function writeSessionCookie(e) {
      var t, r, n, i;
      var o = e.state,
        s = e.session_token,
        a = e.session_jwt,
        c = Jt.generateCookieOpts({
          expiresAt: null !== (r = null === (t = null == o ? void 0 : o.session) || void 0 === t ? void 0 : t.expires_at) && void 0 !== r ? r : "",
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      Vt(this.opaqueTokenCookieName, s, c), Vt(this.jwtCookieName, a, c);
      var u = Jt.generateCookieOpts({
        expiresAt: null !== (i = null === (n = null == o ? void 0 : o.session) || void 0 === n ? void 0 : n.expires_at) && void 0 !== i ? i : "",
        availableToSubdomains: !this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      zt(this.jwtCookieName) && Gt.remove(this.jwtCookieName, u), zt(this.opaqueTokenCookieName) && Gt.remove(this.opaqueTokenCookieName, u), zt(this.jwtCookieName) && We("Could not remove extraneous JWT cookie. This might happen if the cookie has been set using multiple `path` settings, and may produce unwanted behavior."), zt(this.opaqueTokenCookieName) && We("Could not remove extraneous opaque token cookie.");
    }
  }, {
    key: "writeIntermediateSessionTokenCookie",
    value: function writeIntermediateSessionTokenCookie(e) {
      var t = new Date(Date.now() + 6e5),
        r = Jt.generateCookieOpts({
          expiresAt: t.toString(),
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      Vt(this.istCookieName, e, r);
    }
  }, {
    key: "removeSessionCookie",
    value: function removeSessionCookie() {
      this.removeCookies([this.opaqueTokenCookieName, this.jwtCookieName]);
    }
  }, {
    key: "removeISTCookie",
    value: function removeISTCookie() {
      this.removeCookies([this.istCookieName]);
    }
  }, {
    key: "removeCookies",
    value: function removeCookies(e) {
      var _this6 = this;
      [!0, !1].forEach(function (t) {
        [_this6._cookiePath, null].forEach(function (r) {
          [_this6._domain, null].forEach(function (n) {
            var i = Jt.generateCookieOpts({
              expiresAt: new Date(0).toString(),
              availableToSubdomains: t,
              path: r,
              domain: n
            });
            e.forEach(function (e) {
              Gt.remove(e, i);
            });
          });
        });
      }), e.forEach(Yt);
    }
  }, {
    key: "syncToLocalStorage",
    value: function syncToLocalStorage() {
      localStorage.setItem(Wt(this.publicToken), JSON.stringify(this.state));
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return localStorage.getItem(Wt(this.publicToken, e));
    }
  }, {
    key: "setItem",
    value: function setItem(e, t) {
      return localStorage.setItem(Wt(this.publicToken, e), t);
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return localStorage.removeItem(Wt(this.publicToken, e));
    }
  }], [{
    key: "generateCookieOpts",
    value: function generateCookieOpts(_ref4) {
      var e = _ref4.path,
        t = _ref4.domain,
        r = _ref4.availableToSubdomains,
        n = _ref4.expiresAt;
      var i = {
        expires: new Date(n),
        sameSite: "lax"
      };
      return e && (i.path = e), Boolean("localhost" === window.location.hostname || "[::1]" === window.location.hostname || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) ? i.secure = !1 : (r && (i.domain = t || window.location.host), i.secure = !0), i;
    }
  }]);
  return Jt;
}();
var $t = /*#__PURE__*/function (_Jt) {
  _inherits($t, _Jt);
  function $t() {
    _classCallCheck(this, $t);
    return _callSuper(this, $t, arguments);
  }
  return _createClass($t);
}(Jt);
var Xt = Symbol["for"]("__stytch_b2b_DataLayer"),
  Zt = function Zt(e, t) {
    var r = function () {
      var e = window;
      return e[Xt] || (e[Xt] = {}), e[Xt];
    }();
    return r[e] || (r[e] = new $t(e, t)), r[e];
  },
  Qt = function Qt(e, t) {
    Object.values(e).forEach(function (e) {
      return e(t);
    });
  },
  er = function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$KEYS_TO_EXCLUDE = _ref5.KEYS_TO_EXCLUDE,
      e = _ref5$KEYS_TO_EXCLUDE === void 0 ? [] : _ref5$KEYS_TO_EXCLUDE;
    var t = function t(r, n) {
      return _typeof(r) == _typeof(n) && (null === r || null === n ? r === n : "object" == _typeof(r) ? Object.keys(r).length === Object.keys(n).length && !Object.keys(r).some(function (e) {
        return !(e in n);
      }) && Object.entries(r).filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          t = _ref7[0];
        return !e.includes(t);
      }).every(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          e = _ref9[0],
          r = _ref9[1];
        return t(r, n[e]);
      }) : r === n);
    };
    return t;
  }({
    KEYS_TO_EXCLUDE: ["last_accessed_at"]
  });
var tr = /*#__PURE__*/function () {
  function tr(e, t) {
    var _this7 = this;
    _classCallCheck(this, tr);
    this._publicToken = e, this._datalayer = t, this.fromCache = !0, this._listen = function (e) {
      if (e.key !== Wt(_this7._publicToken)) return;
      var t = null === e.newValue || "null" === e.newValue ? null : JSON.parse(e.newValue);
      _this7.updateState(t, !0);
    }, window.addEventListener("storage", this._listen);
    var _this$_datalayer$read = this._datalayer.readSessionCookie(),
      r = _this$_datalayer$read.session_token;
    r || this.destroySession();
  }
  _createClass(tr, [{
    key: "getTokens",
    value: function getTokens() {
      var _this$_datalayer$read2 = this._datalayer.readSessionCookie(),
        e = _this$_datalayer$read2.session_token,
        t = _this$_datalayer$read2.session_jwt;
      return "string" != typeof e || "string" != typeof t ? null : {
        session_token: e,
        session_jwt: t
      };
    }
  }, {
    key: "getIntermediateSessionToken",
    value: function getIntermediateSessionToken() {
      return this._datalayer.readIntermediateSessionTokenCookie() || null;
    }
  }, {
    key: "destroyState",
    value: function destroyState() {
      this.updateStateAndTokens({
        state: null,
        session_token: null,
        session_jwt: null,
        intermediate_session_token: null
      });
    }
  }, {
    key: "destroySession",
    value: function destroySession() {
      this._datalayer.removeSessionCookie(), this.updateState(null);
    }
  }, {
    key: "_updateStateAndTokensInternal",
    value: function _updateStateAndTokensInternal(e) {
      var t = this._datalayer.state,
        r = null === e.state ? null : Object.assign(Object.assign({}, this._datalayer.state), e.state);
      this._datalayer.state = r;
      var n = this.getFromCache();
      this.setCacheRefreshed(), !n && er(t, r) || Qt(this._datalayer.subscriptions, r);
    }
  }, {
    key: "updateStateAndTokens",
    value: function updateStateAndTokens(e) {
      e.state ? (this._datalayer.writeSessionCookie(e), this._datalayer.removeISTCookie()) : e.intermediate_session_token ? (this._datalayer.writeIntermediateSessionTokenCookie(e.intermediate_session_token), this._datalayer.removeSessionCookie()) : (this._datalayer.removeSessionCookie(), this._datalayer.removeISTCookie()), this._updateStateAndTokensInternal(e), this._datalayer.syncToLocalStorage();
    }
  }, {
    key: "updateState",
    value: function updateState(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r = this._datalayer.state,
        n = null === e ? null : Object.assign(Object.assign({}, this._datalayer.state), e);
      this._datalayer.state = n;
      var i = this.getFromCache();
      this.setCacheRefreshed();
      var o = !er(r, n);
      (i || o) && (Qt(this._datalayer.subscriptions, n), o && !t && this._datalayer.syncToLocalStorage());
    }
  }, {
    key: "updateTokens",
    value: function updateTokens(e) {
      var t = e.session_token,
        r = e.session_jwt,
        n = this._datalayer.readSessionCookie(),
        i = Object.assign(Object.assign({}, n), {
          session_token: t,
          session_jwt: r
        });
      t || r ? (this._datalayer.writeSessionCookie(i), this._datalayer.removeISTCookie()) : this._datalayer.removeSessionCookie();
    }
  }, {
    key: "subscribeToState",
    value: function subscribeToState(e) {
      return function (e, t) {
        var r = Math.random().toString(36).slice(-10);
        return e[r] = t, function () {
          return delete e[r];
        };
      }(this._datalayer.subscriptions, e);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._datalayer.state;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("storage", this._listen);
    }
  }, {
    key: "syncFromDeviceStorage",
    value: function syncFromDeviceStorage() {
      return null;
    }
  }, {
    key: "getFromCache",
    value: function getFromCache() {
      return this.fromCache;
    }
  }, {
    key: "setCacheRefreshed",
    value: function setCacheRefreshed() {
      this.fromCache = !1;
    }
  }]);
  return tr;
}();
var rr = /*#__PURE__*/function (_tr) {
  _inherits(rr, _tr);
  function rr() {
    var _this8;
    _classCallCheck(this, rr);
    _this8 = _callSuper(this, rr, arguments), _this8.updateMember = function (e) {
      return _this8.updateState({
        member: e
      });
    }, _this8.getMember = function () {
      var e, t;
      return null !== (t = null === (e = _this8.getState()) || void 0 === e ? void 0 : e.member) && void 0 !== t ? t : null;
    }, _this8.updateOrganization = function (e) {
      return _this8.updateState({
        organization: e
      });
    }, _this8.getOrganization = function () {
      var e, t;
      return null !== (t = null === (e = _this8.getState()) || void 0 === e ? void 0 : e.organization) && void 0 !== t ? t : null;
    }, _this8.getSession = function () {
      var e, t;
      return null !== (t = null === (e = _this8.getState()) || void 0 === e ? void 0 : e.session) && void 0 !== t ? t : null;
    };
    return _this8;
  }
  return _createClass(rr);
}(tr);
var nr = Symbol["for"]("stytch__internal_b2b"),
  ir = "undefined" != typeof window && "IdentityCredential" in window,
  or = function or(e) {
    return e === f.forceLegacyEmbedded ? "force" : e === f.embeddedOnly || e === f.embedded || e === f.floatingOrEmbedded;
  };
var sr = /*#__PURE__*/function () {
  function sr(e, t) {
    _classCallCheck(this, sr);
    this._googleClient = e, this._clientId = t;
  }
  _createClass(sr, [{
    key: "cancel",
    value: function cancel() {
      this._googleClient.cancel();
    }
  }, {
    key: "render",
    value: function render(_ref10) {
      var e = _ref10.callback,
        t = _ref10.onOneTapCancelled,
        r = _ref10.style;
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this9 = this;
        var n, i, o;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              n = or(r.position), i = function (e) {
                var t = or(e);
                return "force" === t || t && !ir;
              }(r.position), o = {
                client_id: this._clientId,
                callback: e,
                auto_select: !1,
                context: "use",
                itp_support: !0,
                use_fedcm_for_prompt: "force" !== n
              };
              return _context13.abrupt("return", (i && (o.prompt_parent_id = "google-parent-prompt", o.cancel_on_tap_outside = !1), this._googleClient.initialize(o), new Promise(function (e) {
                _this9._googleClient.prompt(function (r) {
                  var n, o, s, a, c;
                  if (r.isSkippedMoment()) {
                    var _i = null !== (o = null === (n = r.getSkippedReason) || void 0 === n ? void 0 : n.call(r)) && void 0 !== o ? o : "unknown_reason";
                    return "user_cancel" === _i && (null == t || t()), e({
                      success: !1,
                      reason: _i
                    });
                  }
                  return !r.isNotDisplayed && i || (null === (s = r.isNotDisplayed) || void 0 === s ? void 0 : s.call(r)) ? e({
                    success: !1,
                    reason: null !== (c = null === (a = r.getNotDisplayedReason) || void 0 === a ? void 0 : a.call(r)) && void 0 !== c ? c : "unknown_reason"
                  }) : r.isDismissedMoment() ? void 0 : (_this9.styleFrame(i), e({
                    success: !0
                  }));
                });
              })));
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "styleFrame",
    value: function styleFrame(e) {
      e && Array.from(document.getElementsByTagName("iframe")).forEach(function (e) {
        e.src.includes(Pe) && (e.style.width = "100%");
      });
    }
  }]);
  return sr;
}();
var ar = Promise.resolve({
  pkceRequiredForOAuth: !1
});
var cr = /*#__PURE__*/function () {
  function cr(e, t) {
    var _this10 = this;
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ar;
    _classCallCheck(this, cr);
    this._networkClient = e, this._pkceManager = t, this._config = r, this.createOnDiscoverySuccessHandler = function (_ref11) {
      var e = _ref11.discoveryRedirectUrl,
        t = _ref11.onSuccess,
        r = _ref11.onError;
      return function (n) {
        return Dt(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
          var i, o;
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                i = n.credential;
                o = this.submitGoogleOneTapTokenDiscovery({
                  credential: i,
                  discoveryRedirectUrl: e
                }).then(function (e) {
                  return t(e.redirect_url);
                });
                r && (o = o["catch"](function (e) {
                  return r(e);
                }));
                _context14.next = 5;
                return o;
              case 5:
              case "end":
                return _context14.stop();
            }
          }, _callee14, this);
        }));
      };
    }, this.createOnSuccessHandler = function (_ref12) {
      var e = _ref12.organizationId,
        t = _ref12.signupRedirectUrl,
        r = _ref12.loginRedirectUrl,
        n = _ref12.onSuccess,
        i = _ref12.onError;
      return function (o) {
        return Dt(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
          var s, a;
          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                s = o.credential;
                a = this.submitGoogleOneTapToken({
                  credential: s,
                  organizationId: e,
                  signupRedirectUrl: t,
                  loginRedirectUrl: r
                }).then(function (e) {
                  return n(e.redirect_url);
                });
                i && (a = a["catch"](function (e) {
                  return i(e);
                }));
                _context15.next = 5;
                return a;
              case 5:
              case "end":
                return _context15.stop();
            }
          }, _callee15, this);
        }));
      };
    }, this.RedirectOnSuccess = function (e) {
      window.location.href = e;
    };
  }
  _createClass(cr, [{
    key: "fetchGoogleStart",
    value: function fetchGoogleStart() {
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var e;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!this.googleClientID) {
                _context16.next = 2;
                break;
              }
              return _context16.abrupt("return", this.googleClientID);
            case 2:
              _context16.next = 4;
              return this._networkClient.fetchSDK({
                url: "/b2b/oauth/google/onetap/start",
                method: "GET",
                errorMessage: "Failed to fetch google client ID"
              });
            case 4:
              e = _context16.sent;
              return _context16.abrupt("return", (this.googleClientID = e.google_client_id, this.googleClientID));
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "submitGoogleOneTapTokenDiscovery",
    value: function submitGoogleOneTapTokenDiscovery(_ref13) {
      var e = _ref13.credential,
        t = _ref13.discoveryRedirectUrl;
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var r, _yield$this$_config, n;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this._config;
            case 2:
              _yield$this$_config = _context17.sent;
              n = _yield$this$_config.pkceRequiredForOAuth;
              if (!n) {
                _context17.next = 10;
                break;
              }
              _context17.next = 7;
              return this._pkceManager.startPKCETransaction();
            case 7:
              r = _context17.sent.code_challenge;
              _context17.next = 11;
              break;
            case 10:
              this._pkceManager.clearPKPair();
            case 11:
              _context17.next = 13;
              return this._networkClient.fetchSDK({
                url: "/b2b/oauth/google/onetap/discovery/submit",
                method: "POST",
                body: {
                  id_token: e,
                  discovery_redirect_url: t,
                  pkce_code_challenge: r
                },
                errorMessage: "Failed to submit One Tap ID token for discovery"
              });
            case 13:
              return _context17.abrupt("return", _context17.sent);
            case 14:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "submitGoogleOneTapToken",
    value: function submitGoogleOneTapToken(_ref14) {
      var e = _ref14.credential,
        t = _ref14.organizationId,
        r = _ref14.signupRedirectUrl,
        n = _ref14.loginRedirectUrl;
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var i, _yield$this$_config2, o;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this._config;
            case 2:
              _yield$this$_config2 = _context18.sent;
              o = _yield$this$_config2.pkceRequiredForOAuth;
              if (!o) {
                _context18.next = 10;
                break;
              }
              _context18.next = 7;
              return this._pkceManager.startPKCETransaction();
            case 7:
              i = _context18.sent.code_challenge;
              _context18.next = 11;
              break;
            case 10:
              this._pkceManager.clearPKPair();
            case 11:
              _context18.next = 13;
              return this._networkClient.fetchSDK({
                url: "/b2b/oauth/google/onetap/submit",
                method: "POST",
                body: {
                  id_token: e,
                  organization_id: t,
                  signup_redirect_url: r,
                  login_redirect_url: n,
                  pkce_code_challenge: i
                },
                errorMessage: "Failed to submit One Tap ID token"
              });
            case 13:
              return _context18.abrupt("return", _context18.sent);
            case 14:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "createOneTapClient",
    value: function createOneTapClient() {
      return Dt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var e;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return this.fetchGoogleStart();
            case 3:
              e = _context19.sent;
              _context19.next = 9;
              break;
            case 6:
              _context19.prev = 6;
              _context19.t0 = _context19["catch"](0);
              return _context19.abrupt("return", {
                success: !1,
                reason: _context19.t0.error_type
              });
            case 9:
              if (!("" === e)) {
                _context19.next = 11;
                break;
              }
              return _context19.abrupt("return", {
                success: !1,
                reason: "oauth_config_not_found"
              });
            case 11:
              _context19.t1 = !0;
              _context19.t2 = sr;
              _context19.next = 15;
              return Ke(Oe, function () {
                return window.google.accounts.id;
              });
            case 15:
              _context19.t3 = _context19.sent;
              _context19.t4 = e;
              _context19.t5 = new _context19.t2(_context19.t3, _context19.t4);
              return _context19.abrupt("return", {
                success: _context19.t1,
                client: _context19.t5
              });
            case 19:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this, [[0, 6]]);
      }));
    }
  }]);
  return cr;
}();
var ur = /*#__PURE__*/function (_Nt) {
  _inherits(ur, _Nt);
  function ur(e, t, r, n, i) {
    var _this11;
    _classCallCheck(this, ur);
    var o = r;
    Ve(e) && (o = n), _this11 = _callSuper(this, ur, [e, t, o, i]);
    return _this11;
  }
  return _createClass(ur);
}(Nt);
var lr = /*#__PURE__*/_createClass(function lr(e, t) {
  var _this12 = this;
  _classCallCheck(this, lr);
  var r;
  !function (e) {
    if ("undefined" == typeof window) throw new Error("The ".concat(e, " is not compatible with server-side environments.\nIf using nextjs, use the create").concat(e, " method instead.\n```\n").concat("import { createStytchB2BHeadlessClient } from '@stytch/nextjs/b2b';\n    \n  const stytch = createStytchB2BHeadlessClient('public-token-...');\n  ", "\n```\n"));
  }("StytchB2BHeadlessClient"), "string" != typeof (r = e) ? We("Public token is malformed. Expected a string, got ".concat(_e(r), ".").concat(Ye)) : "" === r ? We('Public token is malformed. Expected "public-token-...", got an empty string.'.concat(Ye)) : r.startsWith("public-token-") || We('Public token is malformed. Expected "public-token-...", got '.concat(r, ".").concat(Ye));
  var n = t,
    i = {
      cookieOptions: null == (o = n) ? void 0 : o.cookieOptions,
      endpoints: {
        sdkBackendURL: null !== (a = null === (s = null == o ? void 0 : o.endpoints) || void 0 === s ? void 0 : s.sdkBackendURL) && void 0 !== a ? a : "https://web.stytch.com",
        testAPIURL: null !== (u = null === (c = null == o ? void 0 : o.endpoints) || void 0 === c ? void 0 : c.testAPIURL) && void 0 !== u ? u : "https://test.stytch.com",
        liveAPIURL: null !== (d = null === (l = null == o ? void 0 : o.endpoints) || void 0 === l ? void 0 : l.liveAPIURL) && void 0 !== d ? d : "https://api.stytch.com",
        dfpBackendURL: null !== (p = null === (h = null == o ? void 0 : o.endpoints) || void 0 === h ? void 0 : h.dfpBackendURL) && void 0 !== p ? p : "https://telemetry.stytch.com",
        clientsideServicesIframeURL: null !== (f = null === (_ = null == o ? void 0 : o.endpoints) || void 0 === _ ? void 0 : _.clientsideServicesIframeURL) && void 0 !== f ? f : "https://js.stytch.com/clientside-services/index.html"
      }
    };
  var o, s, a, c, u, l, d, h, p, _, f;
  this._dataLayer = Zt(e, n), this._subscriptionService = new rr(e, this._dataLayer), this._stateChangeClient = new At(this._subscriptionService, {}), this.onStateChange = function () {
    var _this12$_stateChangeC;
    return (_this12$_stateChangeC = _this12._stateChangeClient).onStateChange.apply(_this12$_stateChangeC, arguments);
  };
  var m = function m() {
      var e, t, r, n;
      return {
        stytch_member_id: null === (t = null === (e = _this12._dataLayer.state) || void 0 === e ? void 0 : e.member) || void 0 === t ? void 0 : t.member_id,
        stytch_member_session_id: null === (n = null === (r = _this12._dataLayer.state) || void 0 === r ? void 0 : r.session) || void 0 === n ? void 0 : n.member_session_id
      };
    },
    v = new Ut(this._dataLayer, "passwords");
  this._networkClient = new Nt(e, this._dataLayer, i.endpoints.sdkBackendURL, m), this._apiNetworkClient = new ur(e, this._dataLayer, i.endpoints.liveAPIURL, i.endpoints.testAPIURL, m);
  var g = new Mt(e, this._networkClient, this._dataLayer),
    b = new Ft(g.getAsync()),
    y = new $e(e, i.endpoints.dfpBackendURL, g.getAsync(), b.executeRecaptcha),
    k = new jt(i.endpoints.clientsideServicesIframeURL),
    w = new Ut(this._dataLayer, "oauth"),
    S = new cr(this._apiNetworkClient, w, g.getAsync());
  this.organization = new it(this._networkClient, this._subscriptionService), this.member = new rt(this._networkClient, this._subscriptionService), this.self = new rt(this._networkClient, this._subscriptionService), this.session = new st(this._networkClient, this._subscriptionService), this.magicLinks = new tt(this._networkClient, this._subscriptionService, new Ut(this._dataLayer, "magic_links"), v, g.getAsync(), y), this.oauth = new Bt(this._networkClient, this._subscriptionService, w, g.getAsync(), {
    publicToken: e,
    testAPIURL: i.endpoints.testAPIURL,
    liveAPIURL: i.endpoints.liveAPIURL
  }, y, S), this.sso = new nt(this._networkClient, this._subscriptionService, new Ut(this._dataLayer, "sso"), g.getAsync(), {
    publicToken: e,
    testAPIURL: i.endpoints.testAPIURL,
    liveAPIURL: i.endpoints.liveAPIURL
  }), this.discovery = new at(this._networkClient, this._subscriptionService), this.passwords = new ut(this._networkClient, this._subscriptionService, v, g.getAsync(), y), this.otps = new lt(this._networkClient, this._subscriptionService, y), this.totp = new dt(this._networkClient, this._subscriptionService, y), this.recoveryCodes = new ht(this._networkClient, this._subscriptionService, y), this.rbac = new pt(g.getSync(), g.getAsync(), this._subscriptionService), this._sessionManager = new mt(this._subscriptionService, this.session);
  var T = new ft(this._networkClient, y);
  this._dataLayer.readSessionCookie().session_token && this._sessionManager.performBackgroundRefresh(), this._networkClient.logEvent({
    name: "b2b_sdk_instance_instantiated",
    details: {
      event_callback_registered: !1,
      error_callback_registered: !1,
      success_callback_registered: !1
    }
  });
  (function (e, t) {
    Object.assign(e, _defineProperty({}, nr, t));
  })(this, {
    bootstrap: g,
    clientsideServices: k,
    publicToken: e,
    searchManager: T,
    dataLayer: this._dataLayer,
    networkClient: this._networkClient,
    oneTap: S
  });
});
export { y as AuthFlowType, k as B2BMFAProducts, w as B2BOAuthProviders, b as B2BProducts, ee as BiometricsFailedError, M as BiometricsUnavailableError, J as ChallengeSigningFailedError, z as DeviceCredentialsNotAllowedError, X as FailedCodeChallengeError, Q as FailedToDecryptDataError, B as InternalError, H as InvalidAuthorizationCredentialError, ie as InvalidCredentialTypeError, re as InvalidRedirectSchemeError, te as InvalidStartUrlError, se as JSONDataNotConvertibleToStringError, F as KeyInvalidatedError, j as KeystoreUnavailableError, oe as MissingAttestationObjectError, W as MissingAuthorizationCredentialIDTokenError, q as MissingGoogleClientIDError, G as MissingPKCEError, V as MissingPublicKeyError, ne as MissingUrlError, N as NoBiometricsEnrolledError, L as NoBiometricsRegistrationError, Y as NoCredentialsPresentError, I as NoCurrentSessionError, p as OAuthProviders, m as OTPMethods, f as OneTapPositions, ce as PasskeysInvalidEncoding, ue as PasskeysMisconfigured, Z as PasskeysUnsupportedError, h as Products, g as RNUIProducts, ae as RandomNumberGenerationFailed, S as SDKAPIUnreachableError, $ as SDKNotConfiguredError, le as SignInWithAppleMisconfigured, D as StytchAPIError, x as StytchAPISchemaError, A as StytchAPIUnreachableError, lr as StytchB2BHeadlessClient, E as StytchError, v as StytchEventType, P as StytchSDKAPIError, R as StytchSDKError, C as StytchSDKSchemaError, T as StytchSDKUsageError, O as UNRECOVERABLE_ERROR_TYPES, K as UserCancellationError, U as UserLockedOutError, _ as Wallets, de as errorToStytchError };
